import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AsyncSelect from "react-select/async";
import { ArrowRight, Plus, Save, Search } from "lucide-react";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { confirmAlert } from "react-confirm-alert";
import CurrencyInput from "react-currency-input-field";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import MaterialTable from "material-table";


import { API } from "../../../../backend";
import { getTrans as t } from "../../../../Localization/translations";
import authHeader from "../../../../services/auth-header";
import AddContractLoanService from "../../../../services/contract/addContractLoanService";
import Helper from "../../../../Helper";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddPartyService from "../../../../services/party/addparty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import AddAssetService from "../../../../services/contract/asset/addAssetService";
import EditItemMasterService from "../../../../services/itemmaster/itemmasterEditServices";
import AddItemmasterService from "../../../../services/itemmaster/itemmasterAddService";
import CreateAddress from "../../Address/createAddress";
import AddCutomer from "../../Customer/addCutomer";
import AddAsset from "../../Asset/addAsset";
import AddVendor from "../../Vendor/addVendor";
import FilterAsset from "../../Asset/filterAsset";
import ContractLeaseSummary from "../../Summary/createSummary";
import lineOfBusinessService from "../../../../services/company/lineofbusinessService";
import subcompanyService from "../../../../services/company/subcompanyService";
import AddcategoryService from "../../../../services/category/categoryAddServices";


const CreateLoan = () => {
    const [planFeatures, setPlanFeatures] = useState(null);
    const [loading, setLoading] = useState(false);
    const [disablebutton, setDisablebutton] = useState(false);
    const [disablevendor, setDisablevendor] = useState(false);
    const [disableparty, setDisableparty] = useState(false);
    const [disableaddress, setDisableAddress] = useState(false);
    const location = useLocation();
    const states = location?.state;

    const [contract_number, setContract_number] = useState("");
    const [description, setDescription] = useState("");
    const [start_date, setStart_date] = useState(new Date());
    const [contract_term, setContract_term] = useState("");
    const [address, setAddress] = useState([]);
    const [address_id, setAdddressId] = useState();
    const [contract_type, setContract_type] = useState(states);
    const [contractID, setContractID] = useState();
    const [end_date, setEnd_date] = useState("");
    const [iir, setIir] = useState(0);
    const [interestonlypayments, setInterestOnlyPayments] = useState(0);
    const [deposit_amount, setDeposit_amount] = useState(0);
    const [feesontime, setFeesOneTime] = useState(0);
    const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
    const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
    const [paymentstartdate, setPaymentStartDate] = useState(null);
    const [loanamount, setLoanAmount] = useState(0);
    const [interestcalculationmethod, setInterestCalculationMethod] =
        useState("Declining Balance");
    const [repaymentprocedure, setRepaymentProcedure] = useState(
        "Equal Monthly Installment"
    );
    const [timecountingmethod, setTimeCountingMethod] = useState("30/360");
    const [interestpostingfrequency, setInterestpostingFrequency] =
        useState("Monthly");
    const [paymentmethod, setPaymentMethod] = useState("Arrears");
    const [contract_number_method_disable, setContract_number_method_disable] =
        useState("");
    const [asset_type, setAssetType] = useState("");
    const [asset_typesetting, setAssetSettingType] = useState("");
    const [asset_typeselection, setAssetTypeSelection] = useState("");
    const [frequency, setFrequency] = useState("Monthly");
    const [paymentrule, setPaymentRule] = useState("Arrears");
    const [successful, setSuccessful] = useState(false);
    const [comment, setComment] = useState("");
    const [addCustomerSource, setAddCustomerSource] = useState(null);
    const checkBtn = useRef();
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        trigger,
        setError,
        formState: { errors },
    } = useForm({ mode: 'onChange' });
    const form = useRef();
    const [extrafiledcontract, setExtraFiled] = useState([]);
    const [filedcontract, setFiledContract] = useState([
        { attribute0: "" },
        { attribute1: "" },
        { attribute2: "" },
        { attribute3: "" },
        { attribute4: "" },
        { attribute5: "" },
        { attribute6: "" },
        { attribute7: "" },
        { attribute8: "" },
        { attribute9: "" },
        { attribute10: "" },
        { attribute11: "" },
        { attribute12: "" },
        { attribute13: "" },
        { attribute14: "" },
    ]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [inputvalue, setInputValue] = useState("");

    const [interestRateType, setInterestRateType] = useState("Fixed");
    const [baseRate, setBaseRate] = useState(0);
    const [margin, setMargin] = useState(0);

    // add party customer
    const form2 = useRef();
    const {
        register: register2,
        handleSubmit: handleSubmit2,
        reset: reset2,
        formState: { errors: errors2 },
    } = useForm();
    const checkBtn2 = useRef();

    const form4 = useRef();
    const checkBtn4 = useRef();
    const {
        register: register4,
        handleSubmit: handleSubmit4,
        reset: reset4,
        formState: { errors: errors4 },
    } = useForm();

    const checkBtn3 = useRef();

    const form5 = useRef();
    const checkBtn5 = useRef();
    const {
        register: register5,
        handleSubmit: handleSubmit5,
        reset: reset5,
        formState: { errors: errors5 },
    } = useForm();

    //party screen
    const [party_type, setParty_type] = useState("Customer");
    const [customer_type, setCustomer_type] = useState("Organization");
    const [showhide, setShowHide] = useState("");
    const [customer_name, setCustomer_name] = useState("");
    const [establishment_date, setEstablishment] = useState(null);
    const [date_of_birth, setDate_of_birth] = useState(null);
    const [disable, setDisable] = useState(false);

    const [party_typevendor, setParty_typeVendor] = useState("Vendor");
    const [customer_typevendor, setCustomer_typeVendor] =
        useState("Organization");
    // const [showhide, setShowHide] = useState("");
    const [customer_namevendor, setCustomer_nameVendor] = useState("");
    const [establishment_datevendor, setEstablishmentVendor] = useState(null);
    const [date_of_birthvendor, setDate_of_birthVednor] = useState(null);

    // Address Screen
    const [address_line_1, setAddress_line_1] = useState("");
    const [address_line_2, setAddress_line_2] = useState("");
    const [city, setCity] = useState("");
    const [state_name, setState] = useState([]);
    const [install_state_name, setInstall_State] = useState([]);
    const [vendor_state_name, setVendor_State] = useState([]);
    const [stateaddress, setStateAddress] = useState("");
    const [zip_code, setZip_code] = useState("");
    const [country, setCountry] = useState("");
    const [countryid, setCountryid] = useState("")
    const [vendorcountryid, setVendorCountryid] = useState("")
    const [installcountryid, setInstallCountryid] = useState("")
    const [stateaddressId, setStateAddressId] = useState("")
    const [venderstateaddressId, setVenderStateAddressId] = useState("")
    const [install_stateaddressId, setInstall_StateAddressId] = useState("")
    const [country_name, setCountry_name] = useState([])
    const [vendor_country_name, setVendor_Country_name] = useState([])
    const [install_country_name, setInstall_Country_name] = useState([])


    const [bill_to, setBill_to] = useState("Yes");
    const [ship_to, setShip_to] = useState("No");
    const [install_to, setInstall_to] = useState("Yes");

    const [installaddress_line_1, setInstallAddress_line_1] = useState("");
    const [installaddress_line_2, setInstallAddress_line_2] = useState("");
    const [installcity, setInstallCity] = useState("");
    const [installzip_code, setInstallZip_code] = useState("");
    const [installcountry, setInstallCountry] = useState("");
    const [installbill_to, setInstallBill_to] = useState("Yes");
    const [installship_to, setInstallShip_to] = useState("No");
    const [installinstall_to, setInstallInstall_to] = useState("Yes");

    const [vendoraddress_line_1, setVendorAddress_line_1] = useState("");
    const [vendoraddress_line_2, setVendorAddress_line_2] = useState("");
    const [vendorcity, setVendorCity] = useState("");
    const [vendorstateaddress, setVendorStateAddress] = useState("");
    const [vendorzip_code, setVendorZip_code] = useState("");
    const [vendorcountry, setVendorCountry] = useState("");
    const [vendorbill_to, setVendorBill_to] = useState("Yes");
    const [vendorship_to, setVendorShip_to] = useState("No");
    const [vendorinstall_to, setVendorInstall_to] = useState("Yes");

    const [selectedAddress, setSelectedAddress] = useState(null);
    const [filteredOptions, setFilteredOptions] = useState([])

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleFields = () => {
        setIsExpanded(!isExpanded);
    };

    const [pacakge, setPackage] = useState([])
    const [companydata, setCompany] = useState([])

    const [formData, setFormData] = useState({});
    const [isEquipment, setIsEquipment] = useState(false);

    const [selectedBill, setSelectedBill] = useState(null);
    const [filterBill, setFilterBill] = useState([])

    const packagedata = async () => {
        const res = await fetch(API + "company/packages/", { headers: authHeader() });
        const getcon = await res.json();
        setPackage(getcon)
    }
    const company = () => {
        GetCompanyInfoService.getCompanyInfo().then(
            (response) => {
                setInstallCountryid(response.data.country)
                setCountryid(response.data.country)
                setVendorCountryid(response.data.country)
                setCompany(response.data)
            })
    }

    useEffect(() => {
        const fetchSubscriptionFeatures = async () => {
            try {
                const response = await axios.get(`${API}paymentsub/subscription/`, {
                    headers: authHeader()
                });

                if (response.data.success === 1 && response.data.data) {
                    setPlanFeatures(response.data.data.plan);
                }
            } catch (error) {
                console.error("Error fetching subscription features:", error);
            }
        };
        fetchSubscriptionFeatures();
    }, []);
    const isFloatingDisabled = planFeatures !== null && planFeatures.floating_rate_loans === false;

    useEffect(() => {
        packagedata()
        company()
    }, [])
    const free = pacakge.filter((value) => value.name === companydata.plan)

    const [state1, setState1] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });

    const [state2, setState2] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });

    const [state4, setState4] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });

    const [state3, setState3] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });


    const [achPayments, setAchPayments] = useState(false); // New state for ACH Payments checkbox
    const [achAccounts, setAchAccounts] = useState([]); // New state for ACH Accounts list
    const [achAccount, setAchAccount] = useState("")

    // New state variables for additional fields
    const [appOriginator, setAppOriginator] = useState("");
    const [source, setSource] = useState("");
    const [salesRep, setSalesRep] = useState("");
    const [subcompany, setSubcompany] = useState("");
    const [lineOfBusiness, setLineOfBusiness] = useState("");
    const [subcompanyOptions, setSubcompanyOptions] = useState([]);
    const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);

    const fetchAchAccounts = async (customerId) => {
        if (!customerId) {
            setAchAccounts([]);
            setAchAccount("");
            setAchPayments(false);
            setValue("achPayments", false); setValue("achAccount", "");
            return;
        }
        try {
            const response = await axios.get(
                `${API}parties/api/ach-accounts/?party_id=${customerId}`,
                { headers: authHeader() }
            );
            const accounts = response.data.details || [];
            setAchAccounts(accounts);
            // Set default ACH Payments based on customer data
            const customerResponse = await axios.get(
                `${API}parties/vendor/?party_type=Customer&&customer_name=${inputvalue}`,
                { headers: authHeader() }
            );
            const customer = customerResponse.data.data.find(
                (c) => c.id === customerId
            );
            console.log("Customer ACH Payments:", customer?.ACHPayments);
            // const achEnabled = customer?.ACHPayments || false;
            // setAchPayments(achEnabled);
            // const defaultAccount = accounts.find((account) => account.is_default === true);
            // const selectedAccountId = defaultAccount ? defaultAccount.id : accounts[0]?.id || "";
            // setAchAccount(selectedAccountId);
            // setValue("achPayments", achEnabled, achAccount: selectedAccountId);
        } catch (error) {
            console.error("Error fetching ACH accounts:", error);
            toast.error("Failed to load ACH accounts");
            setAchAccounts([]);
            setAchAccount("");
            setAchPayments(false);
            setValue("achPayments", false); setValue("achAccount", "");
        }
    };

    const fetchSubcompanies = () => {
        try {
            subcompanyService.getSubcompany().then((response) => {
                const companies = response.data || [];

                setSubcompanyOptions(companies);
                const defaultCompany = companies.find((company) => company.is_default);
                if (defaultCompany) {
                    setSubcompany(defaultCompany.id);
                    setValue("subcompany", defaultCompany.id)
                } else if (companies.length > 0) {
                    // Fallback to first company if no default is set
                    setSubcompany(companies[0].id);
                    setValue("subcompany", companies[0].id)
                }
            });
        } catch (err) {
            console.error(err);
        }
    };

    // Fetch Lines of Business
    const fetchLinesOfBusiness = () => {
        try {
            lineOfBusinessService.getLineOfBusiness().then((response) => {
                const lobs = response.data || [];
                setLineOfBusinessOptions(lobs);
                setLineOfBusinessOptions(lobs);
                // Auto-select the LOB with is_default: true
                const defaultLob = lobs.find((lob) => lob.is_default);
                if (defaultLob) {
                    setLineOfBusiness(defaultLob.id);
                    setValue("lineOfBusiness", defaultLob.id)
                }
                // else if (lobs.length > 0) {
                //   // Fallback to first LOB if no default is set
                //   setLineOfBusiness(lobs[0].id);
                //   reset({
                //     lineOfBusiness:lobs[0].id
                //   })
                // }
            });
        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        fetchAchAccounts(selectedValue);
        fetchSubcompanies();
        fetchLinesOfBusiness();
    }, [selectedValue]);

    useEffect(() => {
        if (subcompanyOptions.length > 0) {
            const defaultCompany = subcompanyOptions.find((c) => c.is_default) || subcompanyOptions[0];
            if (defaultCompany) {
                setSubcompany(defaultCompany.id);
                setValue("subcompany", defaultCompany.id);
            }
        }
    }, [subcompanyOptions]);

    useEffect(() => {
        if (lineOfBusinessOptions.length > 0) {
            const defaultLob = lineOfBusinessOptions.find((lob) => lob.is_default);
            if (defaultLob) {
                setLineOfBusiness(defaultLob.id);
                setValue("lineOfBusiness", defaultLob.id);
            }
        }
    }, [lineOfBusinessOptions]);

    const handleshowhidevendor = (e) => {
        setCustomer_typeVendor(e.target.value);
    };

    const handleshowhide = (e) => {
        const getuser = e.target.value;
        setCustomer_type(e.target.value);
        setShowHide(getuser);
    };

    const handleAddressforInstall = () => {
        setDisableAddress(true)
        form3.current.validateAll();
        if (checkBtn3.current.context._errors.length === 0) {
            if (selectedValue === null) {
                confirmAlert({
                    title: "",
                    message: "Please select customer",
                    buttons: [
                        {
                            label: "OK",
                        },
                    ],
                });
            } else {
                AddPartyAddressService.addPartyAddress(
                    selectedValue,
                    installaddress_line_1,
                    installaddress_line_2,
                    installcity,
                    installstateaddress,
                    installzip_code,
                    installcountry,
                    installbill_to,
                    installship_to,
                    installinstall_to
                    // extrafiledpartyyaddress
                ).then((response) => {
                    if (response.data.success) {
                        setSuccessful(true);
                        toast.success(`${response.data.response}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        setValue("address_id", response.data.addressId, { shouldValidate: true });
                        setReg_address1(response.data.addressId);
                        setTimeout(() => {
                            getinstalladdress(response.data.addressId);
                            setDisableAddress(false)
                            setState2({ isPaneOpen: false });
                        }, 1000);
                        setInstallAddress_line_1("");
                        setInstallAddress_line_2("");
                        setInstallCity("");
                        setInstallStateAddress("");
                        setInstallZip_code("");
                        setInstallCountry("");
                    } else {
                        toast.error(`${response.data.error}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        setDisableAddress(false)

                    }
                })
            }
        }
    };

    const handlepartyvendor = () => {
        AddPartyService.partyvalidate(customer_namevendor).then((response) => {
            if (response.data.success) {
                handleVendorparty();
            } else {
                confirmAlert({
                    title: "",
                    message:
                        `Party ${customer_namevendor} is available.`,
                    // message:
                    //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
                    buttons: [
                        {
                            // label: "Yes",
                            label: "OK",
                            // onClick: () => handleVendorparty(),
                        },
                        // {
                        //   label: "No",
                        // },
                    ],
                });
            }
        })
    };

    const handelDefault = async () => {
        const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
            headers: authHeader(),
        });
        const gtst = await rsst.json();
        setVendorName(await gtst);
    };

    const handleAddressVendor = (id) => {
        form4.current.validateAll();
        if (checkBtn4.current.context._errors.length === 0) {
            AddPartyAddressService.addPartyAddress(
                id,
                vendoraddress_line_1,
                vendoraddress_line_2,
                vendorcity,
                vendorstateaddress,
                vendorzip_code,
                vendorcountry,
                vendorbill_to,
                vendorship_to,
                vendorinstall_to
            ).then((response) => {
                if (response.data.success) {
                    setSuccessful(true);
                    setVendorAddress_line_1("");
                    setVendorAddress_line_2("");
                    setVendorCity("");
                    setVendorStateAddress("");
                    setVendorZip_code("");
                }
            })
        }
    };

    const handleVendorparty = () => {
        setDisablevendor(true)
        form4.current.validateAll();
        let establishmentDate = null;
        let dateofbirth = null;
        if (checkBtn4.current.context._errors.length === 0) {
            if (date_of_birthvendor) {
                dateofbirth = Helper.DatePicker(date_of_birthvendor);
            } else {
                setDate_of_birth(date_of_birth);
            }
            if (establishment_datevendor) {
                establishmentDate = Helper.DatePicker(establishment_datevendor);
            } else {
                setEstablishment(establishment_date);
            }
            AddPartyService.addParty(
                customer_typevendor,
                party_typevendor,
                customer_namevendor
            ).then((response) => {
                if (response.data.success) {
                    toast.success(`${response.data.response}`, {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setValue("vendorname1", response.data.partyId,);
                    setVendorName1(response.data.partyId);
                    handleAddressVendor(response.data.partyId);
                    setTimeout(() => {
                        handelDefault();
                        setDisablevendor(false)
                        setState4({ isPaneOpen: false });
                    }, 1000);
                    setCustomer_nameVendor("");
                } else {
                    setLoading(false);
                    setDisablevendor(false)
                    toast.error(`${response.data.error}`, {
                        position: "top-right",
                        autoClose: 9000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })
        }
    };

    const handleAddress = (id) => {
        form2.current.validateAll();
        if (checkBtn2.current.context._errors.length === 0) {
            AddPartyAddressService.addPartyAddress(
                id,
                address_line_1,
                address_line_2,
                city,
                stateaddress,
                zip_code,
                country,
                bill_to,
                ship_to,
                install_to
            ).then((response) => {
                if (response.data.success) {
                    setSuccessful(true);
                    setAddress_line_1("");
                    setAddress_line_2("");
                    setCity("");
                    setStateAddress("");
                    setZip_code("");
                }
            })
        }
    };

    const handleparty = () => {
        setDisableparty(true)
        form2.current.validateAll();
        let establishmentDate = null;
        let dateofbirth = null;
        if (checkBtn2.current.context._errors.length === 0) {
            if (date_of_birth) {
                dateofbirth = Helper.DatePicker(date_of_birth);
            } else {
                setDate_of_birth(date_of_birth);
            }
            if (establishment_date) {
                establishmentDate = Helper.DatePicker(establishment_date);
            } else {
                setEstablishment(establishment_date);
            }
            AddPartyService.addParty(
                customer_type,
                party_type,
                customer_name
            ).then((response) => {
                if (response.data.success) {
                    setSuccessful(true);
                    setDisable(true);
                    toast.success(`${response.data.response}`, {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    // handleAddress(response.data.partyId);
                    // loadInitialOptions();
                    // reset({
                    //     selectedValue: response.data.partyId,
                    // });
                    // setTimeout(() => {
                    //     setSelectedValue(response.data.partyId);
                    //     setDisableparty(false)
                    //     setState1({ isPaneOpen: false });
                    // }, 1000);

                    // AFTER
                    if (addCustomerSource === 'step1') {
                        handleAddress(response.data.partyId);
                        loadInitialOptions();
                        setValue("selectedValue", response.data.partyId);
                        setTimeout(() => {
                            setSelectedValue(response.data.partyId);
                            setState1({ isPaneOpen: false });
                        }, 1000);
                    } else if (addCustomerSource === 'step4') {
                        loadInitialOptionspartyRole();
                        setTimeout(() => {
                            setSelectedParty({ id: response.data.partyId, customer_name: customer_name });
                            setState1({ isPaneOpen: false });
                        }, 1000);
                    }
                    setAddCustomerSource(null);

                    setCustomer_name("");
                    setCustomer_type("");
                } else {
                    setLoading(false);
                    setSuccessful(false);
                    setDisableparty(false)
                    toast.error(`${response.data.error}`, {
                        position: "top-right",
                        autoClose: 9000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })
        }
    };

    const handlepartydefault = () => {
        AddPartyService.partyvalidate(customer_name).then((response) => {
            if (response.data.success) {
                handleparty();
            } else {
                confirmAlert({
                    title: "",
                    message:
                        `Party ${customer_name} is available.`,
                    // message:
                    //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
                    buttons: [
                        {
                            // label: "Yes",
                            label: "OK",
                            // onClick: () => handleparty(),
                        },
                        // {
                        //   label: "No",
                        // },
                    ],
                });
            }
        })
    };

    const handelInputChange = (value) => {
        setInputValue(value);
    };

    const handelChange = (value) => {
        if (value === null) {
            setSelectedValue(value);
            setValue("selectedValue", value, { shouldValidate: true });
            setAddress([]);
            setAdddressId();
            setReg_address([]);
            setReg_address1("");
        } else {
            setSelectedValue(value.id);
            setValue("selectedValue", value.id, { shouldValidate: true });
            getaddress();
            getinstalladdress()
        }
    };

    const loadOptions = async (inputValue) => {
        if (inputValue !== "") {
            const responseJSON = await axios.get(
                API +
                `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
                { headers: authHeader() }
            );
            return responseJSON.data.data;
        }
    };

    const [options, setOptions] = useState([]);
    const loadInitialOptions = async () => {
        const responseJSON = await axios.get(
            API +
            `parties/vendor/?party_type=Customer&&customer_name=${customer_name}`,
            { headers: authHeader() }
        );
        setOptions(responseJSON.data.data);
    };

    const contract_number_method = async () => {
        const responseJSON = await axios
            .get(API + `contracts/contract_number_method/`, { headers: authHeader() })
            .then((response) => {
                if (response.data.success === 1) {
                    setContract_number_method_disable(response.data.details);
                } else {
                    confirmAlert({
                        title: "",
                        message: "Go to settings and update CompanySettings",
                        buttons: [
                            {
                                label: "OK",
                                onClick: () => navigate("/additionalsettings"),
                            },
                        ],
                    });
                }
            })
    };

    const asset_number_method = async () => {
        const responseJSON = await axios.get(
            API + `contracts/asser_number_series/`, { headers: authHeader() }
        )
            .then((response) => {
                if (response.data.success === 1) {
                    setAssetType(response.data.assettype.split(", "))
                    setAssetSettingType(response.data.assettype)
                }
                else {
                    return false
                }
            })
    }

    const handelStart_Date = (value) => {
        setStart_date(value);
        setValue("startdate", value,);
        trigger("startdate")
    };

    useEffect(() => {
        contract_number_method();
        asset_number_method()
        loadInitialOptions();
    }, []);

    const getExtrafiled = () => {
        GetCompanyInfoService.getExtraFiled().then((response) => {
            setExtraFiled(response.data.existcontract);
        })
    };

    useEffect(() => {
        getExtrafiled();
        // Paymentstartdate();
        getEndDate();
        setValue("startdate", start_date);
        // }, [start_date, end_date, contract_term,interestonlypayments]);
    }, [start_date, contract_term, paymentstartdate, frequency]);

    const onChangeextrafileds = (e, index) => {
        const { name, value } = e.target;
        const rowsInput = [...filedcontract];
        rowsInput[index][name] = value;
        setFiledContract(rowsInput);
    };

    const navigate = useNavigate();

    const handelContract_term = (value) => {
        setContract_term(value);
    };

    const getEndDate = () => {
        if (start_date === "") {
            return false;
        }
        var dt = new Date(paymentstartdate);
        var term = parseInt(contract_term);

        const frequencyMapping = {
            "Monthly": 1,
            "Quarterly": 3,
            "Semi-annual": 6,
            "Annual": 12
        };

        const freqMonths = frequencyMapping[frequency] || 1;

        if (contract_term !== "" && !isNaN(dt)) {
            // Arrears: End = PaymentPeriodStart + term - 1 day
            //   PaymentPeriodStart = PaymentStartDate - freqMonths
            //   => End = PaymentStartDate + (term - freqMonths) - 1 day
            // Advance: End = PaymentStartDate + term - 1 day
            const monthsToAdd = paymentrule === "Arrears" ? (term - freqMonths) : term;
            dt.setMonth(dt.getMonth() + monthsToAdd);
            dt.setDate(dt.getDate() - 1); // -----------------------------------
            // ADD INTEREST-ONLY EXTENSION
            // -----------------------------------
            if (interestonlypayments && parseInt(interestonlypayments) > 0) {
                const extraMonths = parseInt(interestonlypayments) * freqMonths;

                let endYear = dt.getFullYear();
                let endMonth = dt.getMonth() + extraMonths;
                let endDay = dt.getDate();

                // handle month-end safely
                const lastDay = new Date(endYear, endMonth + 1, 0).getDate();
                dt = new Date(endYear, endMonth, Math.min(endDay, lastDay));
            }
            setEnd_date(Helper.Dateview(dt));
        }
    };

    console.log("Calculated End Date:", end_date);
    console.log("Start Date:", start_date);

    const Paymentstartdate = (value) => {
        if (!(value instanceof Date) || isNaN(value)) {
            setPaymentStartDate(null);
            setValue("paymentstartdate", null);
            return;
        }

        setPaymentStartDate(value);
        setValue("paymentstartdate", value);
        // setPaymentStartDate(value)
        // reset({
        //     paymentstartdate: value
        // });
        // trigger("paymentstartdate")
    };
    const isFirstDayOfMonth = (date) => {
        return date.getDate() === 1;
    };

    const getLastDayOfMonth = (year, month) =>
        new Date(year, month + 1, 0).getDate();

    const setenddate = (no_of_payments) => {

        if (start_date === "") {
            return false;
        }

        var contractDateObj = new Date(start_date);
        // Define a mapping for payment frequencies
        const frequencyMapping = {
            Monthly: { months: 1 },
            Quarterly: { months: 3 },
            "Semi-annual": { months: 6 },
            Annual: { months: 12 }
        };
        // Calculate the payment start date based on the payment rule
        let paymentStartDate, paymentEndDate;
        if (paymentrule === "Advance") {
            paymentStartDate = contractDateObj;
        } else if (paymentrule === "Arrears") {
            const cycleDelta = frequencyMapping[frequency];

            const originalDay = contractDateObj.getDate();

            let targetYear = contractDateObj.getFullYear();
            let targetMonth = contractDateObj.getMonth() + cycleDelta.months;

            // Get last valid day of target month
            const lastDay = getLastDayOfMonth(targetYear, targetMonth);

            // If original day > last day, clamp to last day
            const targetDay = Math.min(originalDay, lastDay);

            paymentStartDate = new Date(targetYear, targetMonth, targetDay);
            setPaymentStartDate(paymentStartDate); // keep Date object
            setValue("paymentstartdate", paymentStartDate);
            // if (isFirstDayOfMonth(contractDateObj)) {
            //     paymentStartDate = new Date(contractDateObj);
            //     paymentStartDate = new Date(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + cycleDelta.months, 1);
            //     paymentStartDate.setDate(paymentStartDate.getDate() - 1)

            // }
            // else {
            //     paymentStartDate = new Date(contractDateObj);
            //     paymentStartDate.setMonth(
            //         paymentStartDate.getMonth() + cycleDelta.months
            //     );
            //     paymentStartDate.setDate(paymentStartDate.getDate() - 1)

            // }

        }

        // -----------------------------
        // APPLY INTEREST-ONLY MONTHS
        // -----------------------------

        const freqMonths = frequencyMapping[frequency]?.months || 0;

        // if (interestonlypayments && parseInt(interestonlypayments) > 0) {
        //     const extraMonths = parseInt(interestonlypayments) * freqMonths;

        //     // move payment start date forward
        //     let psYear = paymentStartDate.getFullYear();
        //     let psMonth = paymentStartDate.getMonth() + extraMonths;
        //     let psDay = paymentStartDate.getDate();

        //     let psLastDay = getLastDayOfMonth(psYear, psMonth);
        //     paymentStartDate = new Date(
        //         psYear,
        //         psMonth,
        //         Math.min(psDay, psLastDay)
        //     );
        // }



        //     paymentEndDate = new Date(contractDateObj);
        //     paymentEndDate.setMonth(paymentEndDate.getMonth() + parseInt(contract_term));
        //     paymentEndDate.setDate(paymentEndDate.getDate() - 1);
        //     // extend end date if interest-only exists
        // if (interestonlypayments && parseInt(interestonlypayments) > 0) {
        //     let endExtraMonths = parseInt(interestonlypayments) * freqMonths;

        //     let endYear = paymentEndDate.getFullYear();
        //     let endMonth = paymentEndDate.getMonth() + endExtraMonths;
        //     let endDay = paymentEndDate.getDate();

        //     let lastDay = getLastDayOfMonth(endYear, endMonth);
        //     paymentEndDate = new Date(
        //         endYear,
        //         endMonth,
        //         Math.min(endDay, lastDay)
        //     );
        // }
        // setPaymentStartDate(Helper.DatePicker(paymentStartDate));
        // setPaymentStartDate(paymentStartDate); // keep Date object
        //     setValue("paymentstartdate", paymentStartDate);
    };
    useEffect(() => {
        setenddate()
        // }, [ start_date,frequency, paymentrule,interestonlypayments])
    }, [start_date, frequency, paymentrule])

    //     const getBasePaymentStartDate = () => {
    //     if (!start_date) return null;

    //     const contractDateObj = new Date(start_date);

    //     const frequencyMapping = {
    //         Monthly: 1,
    //         Quarterly: 3,
    //         "Semi-annual": 6,
    //         Annual: 12,
    //     };

    //     const monthsToAdd = frequencyMapping[frequency] || 0;

    //     if (paymentrule === "Advance") {
    //         return new Date(contractDateObj);
    //     }

    //     // Arrears - first payment date after one cycle
    //     let base = new Date(contractDateObj);

    //     // Add the correct number of months (handles year rollover safely)
    //     base.setMonth(base.getMonth() + monthsToAdd);
    //     base.setHours(0, 0, 0, 0)

    //     const originalDay = contractDateObj.getDate();

    //     // If adding months caused day overflow (e.g. Jan 31 → Feb 28/29/30)
    //     // → move to the last valid day of the target month
    //     if (base.getDate() < originalDay) {
    //         // Set to last day of the current month
    //         base.setDate(0); // day 0 = last day of previous month
    //         base.setHours(0, 0, 0, 0); // normalize time
    //     }

    //     // Optional: log for debugging (remove later)
    //     // console.log({
    //     //     start: start_date,
    //     //     frequency,
    //     //     paymentrule,
    //     //     monthsAdded: monthsToAdd,
    //     //     calculatedBase: base.toISOString().slice(0, 10)
    //     // });

    //     return base;
    // };
    const getBasePaymentStartDate = () => {
        if (!start_date) return null;

        const contractDate = new Date(start_date);
        if (isNaN(contractDate)) return null;

        const frequencyMapping = {
            Monthly: 1,
            Quarterly: 3,
            "Semi-annual": 6,
            Annual: 12,
        };

        const monthsToAdd = frequencyMapping[frequency] || 0;

        // Advance → payment on contract date
        if (paymentrule === "Advance") {
            const d = new Date(contractDate);
            d.setHours(0, 0, 0, 0);
            return d;
        }

        // ---------- ARREARS (SAFE MONTH HANDLING) ----------
        const originalDay = contractDate.getDate();

        // Step 1: move to first of month (prevents overflow)
        const base = new Date(contractDate);
        base.setDate(1);

        // Step 2: add months
        base.setMonth(base.getMonth() + monthsToAdd);

        // Step 3: find last day of target month
        const lastDayOfMonth = new Date(
            base.getFullYear(),
            base.getMonth() + 1,
            0
        ).getDate();

        // Step 4: clamp day
        base.setDate(Math.min(originalDay, lastDayOfMonth));
        base.setHours(0, 0, 0, 0);

        return base;
    };
    //     const getBasePaymentStartDate = () => {
    //     if (!start_date) return null;

    //     const contractDateObj = new Date(start_date);

    //     const frequencyMapping = {
    //         Monthly: 1,
    //         Quarterly: 3,
    //         "Semi-annual": 6,
    //         Annual: 12,
    //     };

    //     const monthsToAdd = frequencyMapping[frequency] || 0;

    //     if (paymentrule === "Advance") {
    //         return new Date(contractDateObj);
    //     }

    //     // Arrears
    //     const originalDay = contractDateObj.getDate();
    //     let targetYear = contractDateObj.getFullYear();
    //     let targetMonth = contractDateObj.getMonth() + monthsToAdd;

    //     const lastDay = new Date(targetYear, targetMonth + 1, 0).getDate();
    //     const targetDay = Math.min(originalDay, lastDay);

    //     return new Date(targetYear, targetMonth, targetDay);
    // };

    // useEffect(() => {
    //     if (!start_date || !paymentstartdate) {
    //         setInterestOnlyPayments(0);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     const basePaymentDate = getBasePaymentStartDate();
    //     if (!basePaymentDate) return;

    //     const actualPaymentDate = new Date(paymentstartdate);

    //     // Decide Bill vs Capitalize
    //     const mode = decideBillOrCapitalize(basePaymentDate, actualPaymentDate);

    //     if (mode === "Bill") {
    //         // Month based interest-only
    //         const months =
    //             (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
    //             (actualPaymentDate.getMonth() - basePaymentDate.getMonth());

    //         setInterestOnlyPayments(months);
    //         setInterestOnlyInDays(false);
    //     } else {
    //         // Day based (Capitalize)
    //         const days = Math.ceil(
    //             (actualPaymentDate - basePaymentDate) / (1000 * 60 * 60 * 24)
    //         );

    //         setInterestOnlyPayments(days);
    //         setInterestOnlyInDays(true);
    //     }
    //     setInterestOnlyType(mode)

    //     // AUTO select day convention
    //     setTimeCountingMethod("Actual/360");

    // }, [
    //     paymentstartdate,
    //     start_date,
    //     frequency,
    //     paymentrule,
    //     iir   // 🔥 this line fixes "interest rate change not updating"
    // ]);

    const [capitalizedInterestRate, setCapitalizedInterestRate] = useState(iir);


    const normalizeDate = (d) =>
        new Date(d.getFullYear(), d.getMonth(), d.getDate());
    useEffect(() => {
        if (!start_date || !paymentstartdate) {
            setInterestOnlyPayments(0);
            setInterestOnlyInDays(false);
            setIsInterestOnly(false);   // 🔥 hide UI
            return;
        }

        const rawBase = getBasePaymentStartDate();
        if (!rawBase) return;

        const basePaymentDate = normalizeDate(rawBase);

        const rawActual =
            paymentstartdate instanceof Date
                ? paymentstartdate
                : new Date(paymentstartdate);

        const actualPaymentDate = normalizeDate(rawActual);

        // No interest-only if payment date <= base
        // if (actualPaymentDate <= basePaymentDate) {
        //     setInterestOnlyPayments(0);
        //     setInterestOnlyInDays(false);
        //     setIsInterestOnly(false);   // 🔥 hide UI
        //     return;
        // }
        if (actualPaymentDate.getTime() === basePaymentDate.getTime()) {
            setInterestOnlyPayments(0);
            setInterestOnlyInDays(false);
            setIsInterestOnly(false);
            setInterestOnlyType("");
            return;
        }

        // Frequency → months per period
        const frequencyMonthMap = {
            Monthly: 1,
            Quarterly: 3,
            "Semi-annual": 6,
            Annual: 12,
        };

        const periodMonths = frequencyMonthMap[frequency] || 1;

        // SAME DAY → BILL
        if (actualPaymentDate.getDate() === basePaymentDate.getDate()) {
            const totalMonths =
                (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
                (actualPaymentDate.getMonth() - basePaymentDate.getMonth());



            if (totalMonths > 0 && totalMonths % periodMonths === 0) {
                const billPeriods = totalMonths / periodMonths;

                const rows = [];

                // ✅ START FROM CONTRACT DATE (FIX)
                let periodStart = normalizeDate(new Date(start_date));

                for (let i = 0; i < billPeriods; i++) {
                    const periodEnd = addMonthsSafe(periodStart, periodMonths);

                    // ✅ finance-correct day count
                    const periodDays = daysBetween(periodStart, periodEnd);

                    rows.push({
                        period: i + 1,
                        periodDays,
                        interestRate: iir,
                        dayConvention: dayConvention,
                        billAmount: calculateInterestAmount(
                            vehicle_cost,
                            iir,
                            periodDays,
                            dayConvention
                        ),
                    });

                    periodStart = periodEnd;
                }

                setBilledRows(rows);
                setIsInterestOnly(true);
                setInterestOnlyType("BILL");
                setInterestOnlyPayments(billPeriods);
                setInterestOnlyInDays(false);
                return;
            }
            // const billPeriods = Math.floor(totalMonths / periodMonths);
            // console.log("Bill Periods:", billPeriods); // Debug log
            // console.log("Bill Periods:", billPeriods); // Debug log
            // if (billPeriods > 0) {
            //     setIsInterestOnly(true);               // ✅ SHOW UI
            //     setInterestOnlyPayments(billPeriods);
            //     setInterestOnlyInDays(false);
            //     setInterestOnlyType("BILL");
            // } else {
            //     setIsInterestOnly(false);
            // }
        }
        // DIFFERENT DAY → CAPITALIZE
        else {
            // const days = Math.ceil(
            //     (actualPaymentDate - basePaymentDate) / (1000 * 60 * 60 * 24)
            // );
            // console.log("Capitalize Days:", days); // Debug log
            // console.log("Capitalize Days:", days >0 ); // Debug log

            // if (days > 0) {
            //     console.log("Setting Capitalize Days:", days); // Debug log
            //     setIsInterestOnly(true);               // ✅ SHOW UI
            //     setInterestOnlyPayments(days);
            //     setCapitalizeDays(days);               // 🔥 IMPORTANT
            //     setInterestOnlyInDays(true);
            //     setInterestOnlyType("CAPITALIZE");
            //     const baseDate = normalizeDate(getBasePaymentStartDate());
            // const actualDate = normalizeDate(new Date(paymentstartdate));

            // if (!baseDate || !actualDate) return;

            // // 🔥 Capitalize days = difference between actual and base
            // // let days = calculateCalendarDays(actualDate, baseDate);
            // let days = calculateCalendarDays(baseDate,actualDate);

            // if (days <= 0) {
            //     setIsInterestOnly(false);
            //     return;
            // }

            // finance exclusive adjustment
            // days = days +1;

            //     const contractStart = normalizeDate(new Date(start_date));
            // const paymentStart = normalizeDate(new Date(paymentstartdate));

            // if (!contractStart || !paymentStart) return;

            // // --------------------------------------
            // // Frequency → cycle months
            // // --------------------------------------
            // const frequencyMap = {
            //   Monthly: 1,
            //   Quarterly: 3,
            //   "Semi-annual": 6,
            //   Annual: 12,
            // };

            // const cycleMonths = frequencyMap[frequency] || 1;

            // // --------------------------------------
            // // Accrual start = payment - cycle
            // // --------------------------------------
            // let accrualStart = normalizeDate(
            //   new Date(
            //     paymentStart.getFullYear(),
            //     paymentStart.getMonth() - cycleMonths,
            //     paymentStart.getDate()
            //   )
            // );

            // let days = 0;

            // // --------------------------------------
            // // CASE 1 → Normal accrual
            // // --------------------------------------
            // if (dayConvention === "Actual/360" || dayConvention === "Actual/365") {

            //   days = calculateCalendarDays(contractStart, paymentStart);

            // }
            // // --------------------------------------
            // // 30/360 convention
            // // --------------------------------------
            // else if (dayConvention === "30/360") {

            //   const frequencyMap = {
            //     Monthly: 1,
            //     Quarterly: 3,
            //     "Semi-annual": 6,
            //     Annual: 12,
            //   };

            //   const cycleMonths = frequencyMap[frequency] || 1;

            //   const accrualStart = normalizeDate(
            //     new Date(
            //       paymentStart.getFullYear(),
            //       paymentStart.getMonth() - cycleMonths,
            //       paymentStart.getDate()
            //     )
            //   );

            //   if (accrualStart >= contractStart) {

            //     days = calculateCalendarDays(contractStart, accrualStart);

            //   } else {

            //     const forwardDays = calculateCalendarDays(contractStart, paymentStart);
            //     const cycleDays = 30 * cycleMonths;

            //     days = cycleDays - forwardDays;
            //   }
            // }
            const contractStart = normalizeDate(new Date(start_date));
            const paymentStart = normalizeDate(new Date(paymentstartdate));

            if (!contractStart || !paymentStart) return;
            const frequencyMap = {
                Monthly: 1,
                Quarterly: 3,
                "Semi-annual": 6,
                Annual: 12,
            };
            const cycleMonths = frequencyMap[frequency] || 1
            // Monthly arrears only
            const accrualStart = normalizeDate(
                new Date(
                    paymentStart.getFullYear(),
                    paymentStart.getMonth() - cycleMonths,
                    paymentStart.getDate()
                )
            );

            let days = 0;

            // CASE 1 → Normal accrual
            if (accrualStart >= contractStart) {

                days = calculateCalendarDays(contractStart, accrualStart);

            }
            // CASE 2 → Accrual before contract start
            else {

                //   const forwardDays = calculateCalendarDays(contractStart, paymentStart);
                //   const forwardDays = calculateCalendarDays(contractStart, accrualStart);

                //   // 30-day monthly balancing
                // //   days = 30 - forwardDays;
                //   days =  forwardDays;
                // }
                if (accrualStart < contractStart) {
                    const calcEndDate = new Date(paymentStart);
                    calcEndDate.setDate(calcEndDate.getDate() - 1);
                    const forwardDays = calculateCalendarDays(contractStart, calcEndDate);

                    // const forwardDays = calculateCalendarDays(contractStart, paymentStart);
                    days = -(30 - forwardDays);

                    console.log("Accrual before contract start. Forward days:", forwardDays, "Calculated days:", days);
                }
                else {

                    const forwardDays = calculateCalendarDays(contractStart, accrualStart);
                    days = forwardDays;
                    console.log("Accrual before contract start. Forward days:", forwardDays, "Calculated days:", days);
                }
            }
            // const contractStart = normalizeDate(new Date(start_date));
            // const paymentStart = normalizeDate(new Date(paymentstartdate));

            // if (!contractStart || !paymentStart) return;

            // // Monthly only (your Excel model)
            // const accrualStart = normalizeDate(
            //   new Date(
            //     paymentStart.getFullYear(),
            //     paymentStart.getMonth() - 1,
            //     paymentStart.getDate()
            //   )
            // );

            // let days = 0;

            // // CASE 1 → Normal accrual
            // if (accrualStart >= contractStart) {

            //   days = calculateCalendarDays(contractStart, accrualStart);

            // }
            // // CASE 2 → Accrual before contract start
            // else {

            //   const forwardDays = calculateCalendarDays(contractStart, paymentStart);

            //   days = 30 - forwardDays;

            // }


            let yearBase = 360;
            if (dayConvention === "Actual/365") yearBase = 365;

            const principal = parseFloat(loanamount || vehicle_cost || 0);
            const rate = parseFloat(iir || 0);

            const creditInterest =
                (principal * rate * days) / (100 * yearBase);

            const newPrincipal = principal + creditInterest;

            setIsInterestOnly(true);
            setInterestOnlyType("CAPITALIZE");
            setInterestOnlyPayments(days);
            setCapitalizeDays(days);
            setInterestOnlyInDays(true);

            setCapitalizedInterest(creditInterest.toFixed(2));
            setTotalLoanAmount(newPrincipal.toFixed(2));
            const emi = calculatePMT(
                newPrincipal,
                rate,
                parseInt(contract_term || 0),
                frequency
            );

            setPaymentAmount(emi.toFixed(2));

            // } else {
            //     setIsInterestOnly(false);
            // }
        }

    }, [
        start_date,
        paymentstartdate,
        frequency,
        paymentrule,
        loanamount,
    ]);



    const calculateCalendarDays = (start, end) => {
        const startUTC = Date.UTC(
            start.getFullYear(),
            start.getMonth(),
            start.getDate()
        );

        const endUTC = Date.UTC(
            end.getFullYear(),
            end.getMonth(),
            end.getDate()
        );

        return Math.floor((endUTC - startUTC) / (1000 * 60 * 60 * 24));
    };
    // useEffect(() => {
    //     if (!start_date || !paymentstartdate) {
    //         setInterestOnlyPayments(0);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     const rawBase = getBasePaymentStartDate();
    //         if (!rawBase) return;

    //         const basePaymentDate = normalizeDate(rawBase);

    //         const rawActual =
    //             paymentstartdate instanceof Date
    //                 ? paymentstartdate
    //                 : new Date(paymentstartdate);

    //         const actualPaymentDate = normalizeDate(rawActual);
    //     // const basePaymentDate = getBasePaymentStartDate();
    //     // if (!basePaymentDate) return;
    //     console.log("Base Payment Date:", basePaymentDate);
    //     // const actualPaymentDate =
    //     //     paymentstartdate instanceof Date
    //     //         ? paymentstartdate
    //     //         : new Date(paymentstartdate);
    //     console.log("Actual Payment Date:", actualPaymentDate);
    //     if (isNaN(actualPaymentDate)) {
    //         setInterestOnlyPayments(0);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     // Frequency → months per period
    //     const frequencyMonthMap = {
    //         Monthly: 1,
    //         Quarterly: 3,
    //         "Semi-annual": 6,
    //         Annual: 12,
    //     };

    //     const periodMonths = frequencyMonthMap[frequency] || 1;

    //     // SAME DAY → BILL (PERIOD BASED)
    //     // if (actualPaymentDate.getDate() === basePaymentDate.getDate()) {
    //     //     const totalMonths =
    //     //         (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
    //     //         (actualPaymentDate.getMonth() - basePaymentDate.getMonth());

    //     //     const billPeriods = Math.floor(totalMonths / periodMonths);

    //     //     setInterestOnlyPayments(Math.max(0, billPeriods));
    //     //     setInterestOnlyInDays(false);
    //     //     setInterestOnlyType("BILL");
    //     // }
    //     // // DIFFERENT DAY → CAPITALIZE (DAY BASED)
    //     // else {
    //     //     const days = Math.ceil(
    //     //         (actualPaymentDate - basePaymentDate) / (1000 * 60 * 60 * 24)
    //     //     );

    //     //     setInterestOnlyPayments(Math.max(0, days));
    //     //     setInterestOnlyInDays(true);
    //     //     setInterestOnlyType("CAPITALIZE");
    //     // }
    //     if (actualPaymentDate.getTime() === basePaymentDate.getTime()) {
    //     const totalMonths =
    //         (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
    //         (actualPaymentDate.getMonth() - basePaymentDate.getMonth());

    //     const billPeriods = Math.floor(totalMonths / periodMonths);

    //     setInterestOnlyPayments(Math.max(0, billPeriods));
    //     setInterestOnlyInDays(false);
    //     setInterestOnlyType("BILL");
    // }
    // // DIFFERENT DAY → CAPITALIZE (DAY BASED)
    // else {
    //     const days = Math.ceil(
    //         (actualPaymentDate - basePaymentDate) / (1000 * 60 * 60 * 24)
    //     );

    //     setInterestOnlyPayments(Math.max(0, days));
    //     setInterestOnlyInDays(true);
    //     setInterestOnlyType("CAPITALIZE");
    // }

    // }, [
    //     start_date,
    //     paymentstartdate,
    //     frequency,
    //     paymentrule
    // ]);

    // useEffect(() => {
    //     if (!start_date || !paymentstartdate) {
    //         setInterestOnlyPayments(0);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     const basePaymentDate = getBasePaymentStartDate();
    //     if (!basePaymentDate) {
    //         setInterestOnlyPayments(0);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     const actualPaymentDate = new Date(paymentstartdate);

    //     // No interest-only
    //     if (actualPaymentDate <= basePaymentDate) {
    //         setInterestOnlyPayments(0);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     // 🔹 CASE 1: SAME DAY → MONTH BASED
    //     if (actualPaymentDate.getDate() === basePaymentDate.getDate()) {
    //         const months =
    //             (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
    //             (actualPaymentDate.getMonth() - basePaymentDate.getMonth());

    //         setInterestOnlyPayments(months);
    //         setInterestOnlyInDays(false);
    //         return;
    //     }

    //     // 🔹 CASE 2: MIDDLE DATE → DAY BASED
    //     const days = Math.ceil(
    //         (actualPaymentDate - basePaymentDate) / (1000 * 60 * 60 * 24)
    //     );

    //     setInterestOnlyPayments(days);
    //     setInterestOnlyInDays(true);

    // }, [paymentstartdate, start_date, frequency, paymentrule]);
    const [interestOnlyInDays, setInterestOnlyInDays] = useState(false);

    const getaddress = async () => {
        if (selectedValue !== null) {

            const resst = await fetch(
                API +
                "parties/manage-address/" +
                selectedValue +
                "/?address_type=bill_to",
                { headers: authHeader() }
            );
            const getst = await resst.json();
            setAddress(await getst.data);
            setAdddressId(await getst.data[0].id);
            setValue("billto", await getst.data[0].id, { shouldValidate: true });
        }
    };

    const [reg_address, setReg_address] = useState([]);
    const [installstateaddress, setInstallStateAddress] = useState("");
    const {
        register: register3,
        handleSubmit: handleSubmit3,
        reset: reset3,
        formState: { errors: errors3 },
    } = useForm();
    const form3 = useRef();
    const [reg_address1, setReg_address1] = useState(null);
    const [vehicle_cost, setVehicle_cost] = useState(0);
    const [item, setItems] = useState([]);
    const [vendor_name, setVendorName] = useState([]);
    const [vendername1, setVendorName1] = useState(null);
    const [asset_number, setAsset_number] = useState("");
    const [asset_desc, setAsset_desc] = useState(null);
    const [license_number, setLicense_number] = useState(null);
    const [year, setYear] = useState(null);
    const [vin_number, setVin_number] = useState(null);
    const [license_state, setLicense_state] = useState(null);
    const [manufacturer, setManufacturer] = useState(null);
    const [make, setMake] = useState(null);
    const [model, setModel] = useState(null);
    const [user_purpose, setUser_purpose] = useState(null);
    const [residal_value, seTresidal_value] = useState(0);
    const [delivery_date, setDelivery_date] = useState(null);
    const [in_service_date, setIn_service_date] = useState(null);
    const [milage, setMilage] = useState(0);
    const [tax_amount, setTax_amount] = useState(0);
    const [tax_amount_payto, setTax_amount_payto] = useState("Dealer");
    const [trade_in, setTrade_in] = useState(0);
    const [trade_in_payto, setTrade_in_payto] = useState("Borrower");
    const [reg_cost, setReg_cost] = useState(0);
    const [reg_cost_payto, setReg_cost_payto] = useState("Dealer");
    const [down_payment, setDown_payment] = useState(0);
    const [down_payment_payto, setDown_payment_payto] = useState("Borrower");
    const [vehicle_cost_payto, setVehicle_cost_payto] = useState("Dealer");
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [filteredVendor, setFilterVendor] = useState([])

    const getinstalladdress = async (id) => {
        if (id !== undefined) {
            if (selectedValue !== null) {

                const resst = await fetch(
                    API +
                    "parties/manage-address/" +
                    selectedValue +
                    "/?address_type=install_to",
                    { headers: authHeader() }
                );
                const getst = await resst.json();
                setReg_address(await getst.data);
                setReg_address1(id)
                setValue("address_id", id,);
            };
        } else {
            if (selectedValue !== null) {

                const resst = await fetch(
                    API +
                    "parties/manage-address/" +
                    selectedValue +
                    "/?address_type=install_to",
                    { headers: authHeader() }
                );
                const getst = await resst.json();
                setReg_address(await getst.data);
                setReg_address1(await getst.data[0].id)
                setValue("address_id", await getst.data[0].id,);
            };
        }
    }

    const handlepayment = (contract) => {
        let url = API + "contracts/paymentschedule-view/" + contract + "/";
        axios
            .get(url, { headers: authHeader() })
            .then((response) => setItems(response.data.data))
    };

    const handelvender = async () => {
        const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
            headers: authHeader(),
        });
        const gtst = await rsst.json();
        setVendorName(await gtst);
    };

    const handlefinanced = (contract) => {
        let url = API + "contracts/financedamount/" + contract + "/";
        axios
            .get(url, { headers: authHeader() })
            .then((response) => console.log("data", response.data))
    };

    useEffect(() => {
        getaddress();
        getinstalladdress();
        handelvender();
    }, [selectedValue]);

    // const generateRandomSerialNumber = (length = 5) => {
    //   const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    //   let serialNumber = '';
    //   for (let i = 0; i < length; i++) {
    //     const randomIndex = Math.floor(Math.random() * chars.length);
    //     serialNumber += chars[randomIndex];
    //   }
    //   return serialNumber;
    // };

    const [category_list, setCategory_list] = useState([])
    const [sub_categories, setSub_categories] = useState([])
    const [selected_category, setSelected_category] = useState("")
    const [selected_sub_category, setselected_sub_category] = useState("")
    useEffect(() => {
        AddcategoryService.viewListCategory().then((response) => {
            setCategory_list(response.data.data.categories);
        });
    }, []);

    const handleCategoryChange = (e) => {
        const selectedValue = e.target.value;
        setSelected_category(selectedValue);
        handleItemType(selectedValue)
    }

    useEffect(() => {
        if (selected_category !== "") {
            const matchedCategory = category_list.find(
                (cat) => cat.id === Number(selected_category)
            )
            const category_name = matchedCategory.category_name;
            const item_types = matchedCategory?.item_type
            AddcategoryService.filtersubCategory(category_name).then((response) => {
                const fetchedSubCategories = response.data.sub_categories;
                setSub_categories(fetchedSubCategories);
                const defaultSubCategory = fetchedSubCategories.find(subCat => subCat.is_default === true);
                if (defaultSubCategory) {
                    setselected_sub_category(defaultSubCategory.id.toString());
                    setValue("subcategory", defaultSubCategory.id)
                } else {
                    setselected_sub_category("");
                }
            });
            setValue("item_type", item_types)
        }
    }, [selected_category, category_list])

    const handlesubCategoryChange = (e) => {
        const selectedValue = e.target.value;
        setselected_sub_category(selectedValue);
    }

    const handleItemType = (selectedValue) => {
        const itemval = category_list.find((val) => val.id === parseInt(selectedValue))
        console.log(itemval?.item_type)
        if (itemval) {
            //   setAsset_type(itemval.item_type);
            setValue("item_type", itemval.item_type);
        } else {
            //   setAsset_type('');
            setValue("item_type", '');
        }
    }


    const handleCreateItem = (asset_id, financed_amt) => {
        let itemid = ''
        let description = asset_desc
        let itemname = ''
        let serial_number = ''
        let life_in_months = null
        let netbookvalue = vehicle_cost
        let originalcost = financed_amt
        let item_type = ""
        if (asset_type.length === 1) {
            item_type = asset_typesetting;
        } else {
            item_type = asset_typeselection;
        }
        let status = 'In Transit'
        let category_id = selected_category !== "" ? selected_category : ""
        let sub_category_id = selected_sub_category !== "" ? selected_sub_category : ""
        AddItemmasterService.addItemmaster(
            itemid,
            itemname,
            description,
            serial_number,
            year,
            manufacturer,
            model,
            make,
            Date,
            life_in_months,
            netbookvalue,
            originalcost,
            status,
            asset_id,
            item_type,
            category_id,
            sub_category_id
        ).then(
            (response) => {
                if (response.data.success === 1) {
                    toast.success(`${response.data.response}`, {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setLoading(false)
                }
                else {
                    setLoading(false)
                    setDisable(false)
                    toast.error(`${response.data.error}`, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                }
            },
        )
    }
    const handleExitingInventory = () => {
        let item_type = ""
        if (asset_type.length === 1) {
            item_type = asset_typesetting;
        } else {
            item_type = asset_typeselection;
        }
        if (item_type === '') {
            confirmAlert({
                title: "",
                message: "Please select asset type before select inventory.",
                buttons: [
                    {
                        label: "OK",
                        onClick: () => {
                            setState3({ isPaneOpen: false });
                            setState6({ isPaneOpen: false });
                        },
                    },
                ],
            });
        } else {
            setState3({ isPaneOpen: false });
            setState6({ isPaneOpen: true });
        }
    }

    const handleRegisterasset = (id) => {
        const total_cost = parseFloat(vehicle_cost);
        const financed_amt = parseFloat(total_cost);
        const dealer_pay = parseFloat(total_cost);

        form.current.validateAll();
        let DelecieryDate = null;
        let Inservicedate = null;
        let assettype = "";
        if (checkBtn.current.context._errors.length === 0) {
            if (in_service_date) {
                Inservicedate = Helper.DatePicker(in_service_date);
            } else {
                setIn_service_date(in_service_date);
            }
            if (delivery_date) {
                DelecieryDate = Helper.DatePicker(delivery_date);
            } else {
                setDelivery_date(delivery_date);
            }
            if (vehicle_cost <= 0) {
                toast.error("Please enter valid Vehical Cost ", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setLoading(false);
                return false;
            }
            if (asset_type.length === 1) {
                assettype = asset_typesetting
            }
            else {
                assettype = asset_typeselection
            }
            AddAssetService.addAsset(
                id,
                asset_number,
                formData.asset_desc ? formData.asset_desc : asset_desc,
                formData.license_number ? formData.license_number : license_number,
                financed_amt,
                formData.year ? formData.year : year,
                formData.vin_number ? formData.vin_number : vin_number,
                formData.license_state ? formData.license_state : license_state,
                dealer_pay,
                formData.manufacturer ? formData.manufacturer : manufacturer,
                formData.make ? formData.make : make,
                formData.model ? formData.model : model,
                user_purpose,
                residal_value,
                reg_address1,
                vendername1,
                DelecieryDate,
                formData.in_service_date ? Helper.DatePicker(formData.in_service_date) : Inservicedate,
                formData.mileage ? formData.mileage : milage,
                vehicle_cost,
                vehicle_cost_payto,
                tax_amount,
                tax_amount_payto,
                trade_in,
                trade_in_payto,
                reg_cost,
                reg_cost_payto,
                total_cost,
                down_payment,
                down_payment_payto,
                assettype,
                '',
                item_master_id !== '' ? item_master_id : '',
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                selected_category !== '' ? selected_category : '',
                selected_sub_category !== '' ? selected_sub_category : '',
            ).then((response) => {
                if (response.data.success) {
                    if (asset_desc !== null) {
                        if (item_master_id === '') {
                            // Inventory records should only be created during contract activation, not during asset entry. Disabled per request.
                            // let asset_id = response.data.id
                            // handleCreateItem(asset_id, financed_amt)
                        }
                    }
                    handlefinanced(id);
                    handlepayment(id);
                } else {
                    toast.error(`${response.data.error}`, {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })
        }
    };

    const handleFormKeyDown = async (e) => {
        if (e.key !== "Enter") return;

        // Allow multiline textarea
        if (e.target.tagName === "TEXTAREA") return;

        e.preventDefault();

        if (currentStep < totalSteps) {
            await handleNextClick(e);
        } else {
            handleSubmit(handleRegister)();
        }
    };

    const handleRegister = () => {
        setSuccessful(false);
        setLoading(true);
        setDisablebutton(true)
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            AddContractLoanService.addContract(
                contract_number,
                description,
                selectedValue,
                Helper.DatePicker(start_date),
                contract_term,
                address_id,
                contract_type,
                Helper.DatePicker(end_date),
                Helper.DatePicker(paymentstartdate),
                loanamount,
                iir,
                interestcalculationmethod,
                repaymentprocedure,
                timecountingmethod,
                paymentmethod,
                deposit_amount,
                feesontime,
                tax_rate_rent,
                tax_rate_fee,
                filedcontract,
                frequency,
                paymentrule,
                achPayments,
                achAccount,
                appOriginator,
                source,
                salesRep,
                subcompany,
                lineOfBusiness,
                interestonlypayments,
                contractTerms,
                interestRateType,
                baseRate,
                margin

            ).then((response) => {
                if (response.data.success) {
                    setSuccessful(true);
                    setLoading(false);
                    setContractID(response.data.contractID);
                    setTimeout(() => {
                        navigate("/editloancontract", { state: response.data.contractID });
                    }, 3000);
                    setTimeout(() => {
                        saveInterestOnlyAfterContract(response.data.contractID);
                        handleRegisterasset(response.data.contractID);
                        handlePartyRoleRegister(response.data.contractID);
                    }, 1000);
                    toast.success(`${response.data.response}`, {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                } else {
                    toast.error(`${response.data.error}`, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setDisablebutton(true)
                    setSuccessful(false);
                    setLoading(false);
                }
            })
        }
    };

    const handelClick = () => {
        navigate("/contract");
    };

    const getcountry = async () => {
        const res = await fetch(API + "helper/ajax/load-countries/");
        const getcon = await res.json();
        setCountry_name(await getcon);
        setVendor_Country_name(await getcon);
        setInstall_Country_name(await getcon)
    }

    const getstate = async () => {
        if (countryid) {
            const resst = await fetch(API + "helper/ajax/load-states/" + countryid + "/");
            const getst = await resst.json();
            setState(await getst);
        }
        if (installcountryid) {
            const resst = await fetch(API + "helper/ajax/load-states/" + installcountryid + "/");
            const getst = await resst.json();
            setInstall_State(await getst);
        }
        if (vendorcountryid) {
            const resst = await fetch(API + "helper/ajax/load-states/" + vendorcountryid + "/");
            const getst = await resst.json();
            setVendor_State(await getst);
        }
    };

    const handlecountry = (event) => {
        const getcoutryId = event.target.value;
        setCountryid(getcoutryId)
        const countryName = country_name.filter((val) => val.id === parseInt(getcoutryId))
        const getcountryName = countryName[0]?.name || null;
        setCountry(getcountryName);
        setValue("country_name", getcountryName)
    }

    const handlecountryVendor = (event) => {
        const getcoutryId = event.target.value;
        setVendorCountryid(getcoutryId)
        const countryName = country_name.filter((val) => val.id === parseInt(getcoutryId))
        const getcountryName = countryName[0]?.name || null;
        setVendorCountry(getcountryName);
        setValue("vendor_country_name", getcountryName)
    }
    const handlecountryInstall = (event) => {
        const getcoutryId = event.target.value;
        setInstallCountryid(getcoutryId)
        const countryName = install_country_name.filter((val) => val.id === parseInt(getcoutryId))
        const getcountryName = countryName[0]?.name || null;
        setInstallCountry(getcountryName);
        setValue("install_country_name", getcountryName)
    }

    const handlestate = (event) => {
        const getstateId = event.target.value;
        setStateAddressId(getstateId)

        const stateName = state_name.filter((val) => val.id === parseInt(getstateId))
        const getstateName = stateName[0]?.name || null
        setStateAddress(getstateName)
        setValue("state", getstateName)
    }

    const handlestateVender = (event) => {
        const getstateId = event.target.value;
        setVenderStateAddressId(getstateId)

        const stateName = vendor_state_name.filter((val) => val.id === parseInt(getstateId))
        const getstateName = stateName[0]?.name || null
        setVendorStateAddress(getstateName)
        setValue("vendorstateaddress", getstateName)
    }
    const handlestateInstall = (event) => {
        const getstateId = event.target.value;
        setInstall_StateAddressId(getstateId)

        const stateName = install_state_name.filter((val) => val.id === parseInt(getstateId))
        const getstateName = stateName[0]?.name || null
        setInstallStateAddress(getstateName)
        setValue("install_state_name", getstateName)
    }

    useEffect(() => {
        if (countryid !== null && countryid !== undefined) {
            getstate();
        }
        if (installcountryid !== null && installcountryid !== undefined) {
            getstate();
        }
        if (vendorcountryid !== null && vendorcountryid !== undefined) {
            getstate();
        }
    }, [countryid, installcountryid, vendorcountryid]);

    useEffect(() => {
        getcountry()
    }, [])

    useEffect(() => {
        if (countryid) {
            const countryName = country_name.filter((val) => val.id === parseInt(countryid));
            const getcountryName = countryName[0]?.name || null;
            setCountry(getcountryName);
            setValue("country_name", getcountryName);
        }
    }, [countryid, country_name]);

    useEffect(() => {
        if (installcountryid) {
            const countryName = install_country_name.filter((val) => val.id === parseInt(installcountryid));
            const getcountryName = countryName[0]?.name || null;
            setInstallCountry(getcountryName);
            setValue("install_country_name", getcountryName);
        }
    }, [installcountryid, install_country_name])

    useEffect(() => {
        if (vendorcountryid) {
            const countryName = vendor_country_name.filter((val) => val.id === parseInt(vendorcountryid));
            const getcountryName = countryName[0]?.name || null;
            setVendorCountry(getcountryName);
            setValue("vendorcountry", getcountryName);
        }
    }, [vendorcountryid, vendor_country_name])


    const loadOptionInstallAdd = async (inputValue, callback) => {
        const filteredOptions = reg_address.filter((address) =>
            `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
                .toLowerCase()
                .includes(inputValue.toLowerCase())
        ).map((address) => ({
            value: address.id,
            label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
        }));

        setFilteredOptions(filteredOptions)
        callback(filteredOptions);
    };

    useEffect(() => {
        const options = reg_address.map((address) => ({
            value: address.id,
            label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
        }));
        setFilteredOptions(options)
    }, [customer_name, reg_address])

    const handleAddressChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedAddress(selectedOption.value);
            setReg_address1(selectedOption.value)
            setValue("address_id", selectedOption.value, { shouldValidate: true })
        } else {
            setSelectedAddress(null);
            setReg_address1(null)
            setValue("address_id", null, { shouldValidate: true })
        }
        trigger("address_id");
    };

    useEffect(() => {
        if (reg_address1 && filteredOptions.find((val) => val.value === reg_address1)) {
            trigger("address_id");
        }
    }, [reg_address1, filteredOptions, trigger]);

    const loadOptionVendorName = async (inputValue, callback) => {
        const filteredOptions = vendor_name.filter((val) =>
            val.customer_name
                .toLowerCase()
                .includes(inputValue.toLowerCase())
        ).map((values) => ({
            value: values.id,
            label: values.customer_name
        }));

        setFilterVendor(filteredOptions)
        callback(filteredOptions);
    };

    useEffect(() => {
        const options = vendor_name.map((val) => ({
            value: val.id,
            label: val.customer_name
        }));
        setFilterVendor(options)
    }, [vendor_name])

    const handleVendorChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedVendor(selectedOption.value);
            setVendorName1(selectedOption.value)
            setValue("vendorname1", selectedOption.value, { shouldValidate: true })
        } else {
            setSelectedVendor(null);
            setVendorName1(null)
        }
    };

    const handlePartyAsset = () => {
        setFormData({
            asset_desc: asset_desc,
            asset_number: asset_number,
            make: make,
            manufacturer: manufacturer,
            mileage: milage,
            model: model,
            vin_number: vin_number,
            year: year,
            in_service_date: in_service_date,
            license_number: license_number,
            license_state: license_state
        });
        // if (form5.current) {
        //   setAsset_desc('')
        //   setVin_number('')
        //   setYear('')
        //   setManufacturer('')
        //   setMake('')
        //   setModel('')
        //   setIn_service_date('')
        //   setMilage(null)
        //   setTimeout(() => {
        //     setState3({ isPaneOpen: false });
        //   }, 2000);
        // }
        reset5({
            asset_desc: asset_desc,
            year: year,
            make: make,
            model: model,
            manufacturer: manufacturer
        })
        setValue("vehiclecost", vehicle_cost)
        setTimeout(() => {
            setState3({ isPaneOpen: false });
            setState6({ isPaneOpen: false });
        }, 2000);
    };

    const handlevin = (e) => {
        if (vin_number === "") {
            return false
        }
        else {
            let url = `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${e.target.value}?format=json`;
            axios.get(url, { headers: authHeader() })
                .then((response) => {
                    // setVinDecode(response.data)
                    setMake(response.data.Results[0].Make)
                    setModel(response.data.Results[0].Model)
                    setManufacturer(response.data.Results[0].Manufacturer)
                    setYear(response.data.Results[0].ModelYear)
                }
                )
        }
    }

    useEffect(() => {
        setIsEquipment(asset_typeselection === 'Equipment');
    }, [asset_typeselection]);

    const loadOptionBillAdd = async (inputValue, callback) => {
        const filteredOptions = address.filter((address) =>
            `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
                .toLowerCase()
                .includes(inputValue.toLowerCase())
        ).map((address) => ({
            value: address.id,
            label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
        }));

        setFilterBill(filteredOptions)
        callback(filteredOptions);
    };

    useEffect(() => {
        const options = address.map((address) => ({
            value: address.id,
            label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
        }));
        setFilterBill(options)
    }, [address])

    const handleBillAddressChange = (selectedOption) => {
        if (selectedOption) {
            setAdddressId(selectedOption.value);
            setValue("billto", selectedOption.value, { shouldValidate: true });
        } else {
            setAdddressId(null)
            setSelectedBill(null)
            setValue("billto", null, { shouldValidate: true });
        }
        trigger("billto");
    };

    useEffect(() => {
        if (address_id && filterBill.find((val) => val.value === address_id)) {
            trigger("billto");
        }
    }, [address_id, filterBill, trigger]);

    const [state6, setState6] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });
    const [itemSelect, setItemSelect] = useState('')

    const [valueItem, setValueItem] = useState('')
    const [valueNumber, setValueNumber] = useState()
    const [selectSerial, setSelectSerial] = useState('')

    const [selectModel, setselectModel] = useState('')
    const [valueModel, setValueModel] = useState('')

    const [selectMake, setselectMake] = useState('')
    const [valueMake, setValueMake] = useState('')

    const [selectManu, setselectManu] = useState('')
    const [valueManu, setValueManu] = useState('')

    const [item_master_id, setItem_master_id] = useState('')

    const [inventory_option, setInventory_option] = useState([])
    const loadOptionItem = async (inputValue) => {
        if (inputValue !== "") {
            const responseJSON = await axios.get(
                API + `contracts/itemmaster/filter/?itemname=${inputValue}`,
                { headers: authHeader() }
            );
            return responseJSON.data.data;
        }
    };

    const handelInputChangeItem = (value) => {
        setValueItem(value);
    };

    const handelChangeItem = (value) => {
        setItemSelect(value);
    };

    const loadOptionsserial = async (inputValue2) => {
        if (inputValue2 !== "") {
            const response = await axios.get(
                API + `contracts/itemmaster/filter/?serialnumber=${inputValue2}`,
                { headers: authHeader() }
            );
            return response.data.data;
        }
    };
    const handelChangeserial = (value1) => {
        setSelectSerial(value1);
    };
    const handelInputChangeSerial = (value1) => {
        setValueNumber(value1);
    };

    const handelChangemodel = (value1) => {
        setselectModel(value1);
    };

    const handelInputChangeModel = (value1) => {
        setValueModel(value1);
    };

    const handelChangeMake = (value1) => {
        setselectMake(value1);
    };

    const handleAssetType = (value) => {
        setAssetTypeSelection(value);
        setValue("assettype", value)

    }

    const hanldevehiclecost = (value) => {
        setVehicle_cost(value)
        setValue("vehiclecost", value)
    }

    const handleDescription = (value) => {
        setAsset_desc(value);
        setValue("asset_desc", value)
    }


    const loadOptionsMake = async (inputValue4) => {
        if (inputValue4 !== "") {
            const response = await axios.get(
                API + `contracts/itemmaster/filter/?make=${inputValue4}`,
                { headers: authHeader() }
            );
            return response.data.data;
        }
    };

    const handelInputChangeMake = (value1) => {
        setValueMake(value1);
    };


    const loadOptionsModel = async (inputValue3) => {
        if (inputValue3 !== "") {
            const response = await axios.get(
                API + `contracts/itemmaster/filter/?model=${inputValue3}`,
                { headers: authHeader() }
            );
            return response.data.data;
        }
    };

    const handelChangeManu = (value1) => {
        setselectManu(value1);
    };

    const loadOptionsManu = async (inputValue6) => {
        if (inputValue6 !== "") {
            const response = await axios.get(
                API + `contracts/itemmaster/filter/?manufacturer=${inputValue6}`,
                { headers: authHeader() }
            );
            return response.data.data;
        }
    };
    const handelInputChangeManu = (value1) => {
        setValueManu(value1);
    };

    const handleClear = () => {
        setItemSelect("");
        setSelectSerial("");
        setselectModel("");
        setselectMake("");
        setselectManu("");
        setAsset_desc('')
        setItem_master_id(null)
        setYear('')
        setMake("")
        setModel("")
        setManufacturer("")
        setInventory_option([])
        setVehicle_cost(0)
        reset5({
            asset_desc: '',
            year: '',
            make: '',
            model: '',
            manufacturer: ''
        })
        setState3({ isPaneOpen: false });
        setState6({ isPaneOpen: false });
    };

    const handelSearch = () => {
        let item_type = ""
        if (asset_type.length === 1) {
            item_type = asset_typesetting;
        } else {
            item_type = asset_typeselection;
        }
        axios.get(`${API}contracts/search/itemmaster/?description=${asset_desc ? asset_desc : ''}&contract_type=${contract_type}&item_type=${item_type}&itemname=${itemSelect ? itemSelect.itemname : ""}&serialnumber=${selectSerial ? selectSerial.serialnumber : ""}&model=${selectModel ? selectModel.model : ""}&make=${selectMake ? selectMake.make : ""}&manufacturer=${selectManu ? selectManu.manufacturer : ""}`, {
            headers: authHeader()
        }).then((res) => {
            const optionsList = res.data.map(val => val);
            setInventory_option(optionsList);
            // setState3({ isPaneOpen: true });
        }).catch(error => {
            console.error('Error fetching data:', error);
        });
    };

    useEffect(() => {
        let item_type = ""
        if (asset_type.length === 1) {
            item_type = asset_typesetting;
        } else {
            item_type = asset_typeselection;
        }
        axios.get(`${API}contracts/search/itemmaster/?description=${asset_desc ? asset_desc : ''}&contract_type=${contract_type}&item_type=${item_type}&itemname=${itemSelect ? itemSelect.itemname : ""}&serialnumber=${selectSerial ? selectSerial.serialnumber : ""}&model=${selectModel ? selectModel.model : ""}&make=${selectMake ? selectMake.make : ""}&manufacturer=${selectManu ? selectManu.manufacturer : ""}`, {
            headers: authHeader()
        }).then((res) => {
            const optionsList = res.data.map(val => val);
            setInventory_option(optionsList);
            // setState3({ isPaneOpen: true });
        }).catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [asset_typeselection, asset_typesetting, state6])

    useEffect(() => {
        reset5({
            asset_desc: asset_desc
        })
    }, [asset_desc]);

    const handleTagClick = (tag) => {
        setItem_master_id(tag.id);

        setState3({ isPaneOpen: true });
        // setState6({ isPaneOpen: false });
    };
    useEffect(() => {
        if (item_master_id) {
            EditItemMasterService.getItemmaster(item_master_id).then(
                (response) => {
                    setAsset_desc(response.data.description)
                    setYear(response.data.yearofmanufacture)
                    setMake(response.data.make)
                    setModel(response.data.model)
                    setManufacturer(response.data.manufacturer)
                    setVehicle_cost(response.data.netbookvalue)
                    setLoading(false)
                }
            )
        }
    }, [item_master_id])

    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 5;

    const nextStep = () => {
        setCurrentStep(Math.min(currentStep + 1, totalSteps));
    };

    const prevStep = () => {
        setCurrentStep(Math.max(currentStep - 1, 1));
        reset(undefined, { keepValues: true, keepErrors: false });
    };

    const handleNextClick = async (e) => {
        e.preventDefault();

        let fieldsToValidate = [];

        if (currentStep === 1) {
            fieldsToValidate = ["selectedValue", "billto", "address_id", "startdate", "contract_term"];
            if (contract_number_method_disable === "Manual") {
                fieldsToValidate.push("contract_number");
            }
        } else if (currentStep === 2) {
            fieldsToValidate = ["vendorname1", "assettype", "asset_desc"];
        } else if (currentStep === 3) {
            fieldsToValidate = ["vehiclecost", "interest", "frequency"];
            if (achPayments && !achAccount) {
                setError("achAccount", {
                    type: "manual",
                    message: "Please select Bank Account for ACH Payments",
                });
                return;
            }
        } else if (currentStep === 4) {
            fieldsToValidate = ["party", "role"];
        }

        try {
            const isValid = await trigger(fieldsToValidate);
            if (isValid) {
                nextStep();
            } else {
                const invalidFields = fieldsToValidate.filter((field) => !!errors[field]);
            }
        } catch (error) {
            console.error("Validation error:", error);
            toast.error("An error occurred during validation");
        }
    };

    const handelCancelClick = () => {
        navigate("/contract");
    };

    const [formDataParty, setFormDataParty] = useState({
        party: "",
        role: "",
        contract: "",
    });

    //   const handlePartyRoleRegister = (contract_id) => {
    // form.current.validateAll();

    // if (checkBtn.current.context._errors.length === 0) {

    // formDataParty.party = selectedParty
    // formDataParty.role = role
    // formDataParty.contract = contract_id

    // axios
    //     .post(`${API}contracts/party-roles/create/`, formDataParty, { headers: authHeader() })
    //     .then((response) => {
    // if (response.data.success === 1) {
    //     toast.success("Party Role added successfully", {
    //         position: "top-right",
    //         autoClose: 1000,
    //         hideProgressBar: false,
    //         pauseOnHover: true,
    //         draggable: true,
    //         theme: "light",
    //     });
    // setTimeout(() => {
    //     setHideShow(true); // Navigate back to the list
    // }, 1000);
    // } else {
    //     toast.error(response.data.error || "Failed to add Party Role", {
    //         position: "top-right",
    //         autoClose: 1000,
    //         hideProgressBar: false,
    //         pauseOnHover: true,
    //         draggable: true,
    //         theme: "light",
    //     });
    // }
    // })
    // .catch((error) => {
    //     toast.error("Error adding Party Role", {
    //         position: "top-right",
    //         autoClose: 1000,
    //         hideProgressBar: false,
    //         pauseOnHover: true,
    //         draggable: true,
    //         theme: "light",
    //     });
    // });
    // }
    // };


    const [selectedParty, setSelectedParty] = useState(null);

    // const [selectedParty, setselectedParty] = useState(null);
    const [inputpartyvalue, setValueparty] = useState("");
    // const [partyoptions, setPartyOptions] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);

    const [role, setRole] = useState("");
    const [rolesList, setRolesList] = useState([]);
    const [valueParty, setValueParty] = useState("");

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await axios.get(`${API}company/companysettingsview/`, { headers: authHeader() });
                if (response.data.party_roles) {
                    const roles = response.data.party_roles.split(',').map(r => r.trim());
                    setRolesList(roles);
                }
            } catch (error) {
                console.error("Error fetching company settings:", error);
                toast.error("Failed to load party roles");
            }
        };
        fetchRoles();
    }, []);

    // const handelInputChangeparty = (value) => {
    //     setValueparty(value);
    //   };

    //   const handelChangeparty = (value) => {
    //     if (value === null) {
    //       setselectedParty(value);
    //       reset({
    //         selectedParty: value,
    //       });

    //     } else {
    //       setselectedParty(value.id);
    //       reset({
    //         selectedParty: value.id,
    //       });

    //     }
    //     trigger("selectedParty");

    //   };

    //   const loadOptionsparty = async (inputValue) => {
    //     if (inputValue !== "") {
    //       const responseJSON = await axios.get(
    //         API +
    //         `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
    //         { headers: authHeader() }
    //       );
    //       return responseJSON.data.data;
    //     }
    //   };

    //   const loadInitialOptionspartyRole = async () => {
    //         const responseJSON = await axios.get(
    //             API +
    //             `parties/vendor/?party_type=Customer&&customer_name=`,
    //             { headers: authHeader() }
    //         );
    //         setPartyOptions(responseJSON.data.data);
    //         };

    const loadOptionsparty = async (inputValue) => {
        if (inputValue !== "") {
            const responseJSON = await axios.get(
                API +
                `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
                { headers: authHeader() }
            );
            return responseJSON.data.data;
        }
    };

    const loadInitialOptionspartyRole = async () => {
        const responseJSON = await axios.get(
            API + `parties/vendor/?party_type=Customer&&customer_name=`,
            { headers: authHeader() }
        );
        setPartyOptions(responseJSON.data.data);
    };

    useEffect(() => {

        // loadInitialOptionspartyRole();
        loadInitialOptionspartyRole()
    }, []);

    // Add party role to local state
    const addPartyRole = () => {
        if (selectedParty && role) {
            setPartyRoles([...partyRoles, { partyId: selectedParty.id, partyName: selectedParty.customer_name, role, comment: comment || "" }]);
            setSelectedParty(null);
            setRole('');
            setComment('');
            setValue("selectedParty", null);
        } else {
            toast.error("Please select both party and role");
        }
    };

    // Delete party role from local state
    const deletePartyRole = (index) => {
        const updated = partyRoles.filter((_, i) => i !== index);
        setPartyRoles(updated);
    };

    const handelInputChangeparty = (value) => {
        setValueParty(value);
    };

    const handelChangeparty = (value) => {
        setSelectedParty(value);
        setValue("selectedParty", value ? value.id : null);
    };

    const [partyRoles, setPartyRoles] = useState([]);

    // Modified handlePartyRoleRegister to use party_role_create endpoint
    const handlePartyRoleRegister = async (contractID) => {
        for (const pr of partyRoles) {
            try {
                await axios.post(
                    `${API}contracts/party-roles/create/`,
                    { party: pr.partyId, contract: contractID, role: pr.role, comment: pr.comment },
                    { headers: authHeader() }
                );
                toast.success(`Party role ${pr.role} added successfully`);
            } catch (error) {
                console.error("Error adding party role:", error);
                toast.error("Failed to add party role");
            }
        }
    };


    // -----------------------------
    // Interest Only – NEW STATES
    // -----------------------------
    const [isInterestOnly, setIsInterestOnly] = useState(false);
    const [interestOnlyType, setInterestOnlyType] = useState(""); // BILLED | CAPITALIZED
    const [interestOnlyPeriods, setInterestOnlyPeriods] = useState(0);

    // Capitalized screen fields
    const [capitalizeDays, setCapitalizeDays] = useState(0);
    const [dayConvention, setDayConvention] = useState("Actual/360");

    const [paymentAmount, setPaymentAmount] = useState("0.00");
    // Billed Interest Only rows
    const [billedRows, setBilledRows] = useState([]);
    useEffect(() => {
        if (interestOnlyType === "CAPITALIZE") {
            setCapitalizedInterestRate(iir);
        }
    }, [iir, interestOnlyType]);
    const calculateInterestAmount = (principal, rate, days, convention) => {
        if (!principal || !rate) return "0.00";
        let yearBase = 360;
        if (convention === "Actual/365") yearBase = 365;
        if (convention === "Actual/360") yearBase = 360;
        if (convention === "30/360") {
            if (interestOnlyType === "CAPITALIZE") {
                days = capitalizeDays;
            }
            else {

                days = 30;
            }
        }
        console.log({ principal, rate, days, convention, yearBase });
        return (
            (principal * (rate / 100) * days) / yearBase
        ).toFixed(2);
    };

    const [actualInterestDays, setActualInterestDays] = useState(0);

    // useEffect(() => {
    //     if (!start_date || !paymentstartdate) {
    //         setActualInterestDays(0);
    //         return;
    //     }

    //     const baseDate = getBasePaymentStartDate();
    //     if (!baseDate) return;

    //     const paymentDate = new Date(paymentstartdate);
    //     // const paymentDate = new Date(start_date);
    //     if (isNaN(paymentDate)) return;

    //     const diffDays = Math.ceil(
    //         (paymentDate - baseDate) / (1000 * 60 * 60 * 24)
    //     );

    //     setActualInterestDays(Math.max(0, diffDays));
    // }, [start_date, paymentstartdate, paymentrule]);

    // const calculateBasePaymentStartDate = () => {
    //     if (!start_date) return null;

    //     const contractDate = new Date(start_date);
    //     if (isNaN(contractDate)) return null;

    //     const frequencyMapping = {
    //         Monthly: 1,
    //         Quarterly: 3,
    //         "Semi-annual": 6,
    //         Annual: 12,
    //     };

    //     const monthsToAdd = frequencyMapping[frequency] || 0;

    //     if (paymentrule === "Advance") {
    //         const d = new Date(contractDate);
    //         d.setHours(0, 0, 0, 0);
    //         return d;
    //     }

    //     // -------- ARREARS (PURE CALCULATION) --------
    //     const originalDay = contractDate.getDate();

    //     const base = new Date(contractDate);
    //     base.setDate(1);
    //     base.setMonth(base.getMonth() + monthsToAdd);

    //     const lastDay = new Date(
    //         base.getFullYear(),
    //         base.getMonth() + 1,
    //         0
    //     ).getDate();

    //     base.setDate(Math.min(originalDay, lastDay));
    //     base.setHours(0, 0, 0, 0);

    //     return base;
    // };
    const calculateBasePaymentStartDate = () => {
        if (!start_date) return null;

        const contractDate = new Date(start_date);
        if (isNaN(contractDate)) return null;

        contractDate.setHours(0, 0, 0, 0);
        return contractDate;
    };
    useEffect(() => {
        if (!start_date || !paymentstartdate) {
            setActualInterestDays(0);
            return;
        }

        const baseDate = calculateBasePaymentStartDate();
        if (!baseDate) {
            setActualInterestDays(0);
            return;
        }

        const actualDate =
            paymentstartdate instanceof Date
                ? new Date(paymentstartdate)
                : new Date(paymentstartdate);

        if (isNaN(actualDate)) {
            setActualInterestDays(0);
            return;
        }

        // 🔑 Frequency month mapping
        const frequencyMonthsMap = {
            Monthly: 1,
            Quarterly: 3,
            "Semi-annual": 6,
            Annual: 12,
        };

        const freqMonths = frequencyMonthsMap[frequency] || 0;

        // 🧠 Subtract one full frequency cycle
        const adjustedActualDate = new Date(actualDate);
        adjustedActualDate.setDate(1); // prevent overflow
        adjustedActualDate.setMonth(adjustedActualDate.getMonth() - freqMonths);

        // Clamp day to valid last day
        const lastDay = new Date(
            adjustedActualDate.getFullYear(),
            adjustedActualDate.getMonth() + 1,
            0
        ).getDate();

        adjustedActualDate.setDate(
            Math.min(actualDate.getDate(), lastDay)
        );
        adjustedActualDate.setHours(0, 0, 0, 0);

        // If no delay beyond first cycle → no interest-only days
        if (adjustedActualDate <= baseDate) {
            setActualInterestDays(0);
            return;
        }

        const days = Math.round(
            (adjustedActualDate - baseDate) / (1000 * 60 * 60 * 24)
        );

        setActualInterestDays(days);
    }, [start_date, paymentstartdate, frequency, paymentrule]);
    console.log({ actualInterestDays });
    const addMonthsSafe = (date, months) => {
        const d = new Date(date);
        const day = d.getDate();

        d.setDate(1);
        d.setMonth(d.getMonth() + months);

        const lastDay = new Date(
            d.getFullYear(),
            d.getMonth() + 1,
            0
        ).getDate();

        d.setDate(Math.min(day, lastDay));
        d.setHours(0, 0, 0, 0);
        return d;
    };
    // const daysBetween = (from, to) =>
    //     Math.ceil((to - from) / (1000 * 60 * 60 * 24));

    const daysBetween = (from, to) => {
        const start = new Date(from);
        const end = new Date(to);

        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        // 🔑 Finance rule: end date NOT included
        return Math.round(
            (end - start) / (1000 * 60 * 60 * 24)
        );
    };
    useEffect(() => {
        if (interestOnlyType !== "BILL") return;
        if (!billedRows.length) return;

        const frequencyMonthsMap = {
            Monthly: 1,
            Quarterly: 3,
            "Semi-annual": 6,
            Annual: 12,
        };

        const cycleMonths = frequencyMonthsMap[frequency] || 1;

        const baseDate = calculateBasePaymentStartDate();
        if (!baseDate) return;

        let periodStart = new Date(baseDate);

        const updated = billedRows.map((row, index) => {
            const periodEnd = addMonthsSafe(periodStart, cycleMonths);
            const periodDays = daysBetween(periodStart, periodEnd);

            const billAmount = calculateInterestAmount(
                vehicle_cost,
                row.interestRate || iir,
                periodDays,          // ✅ CORRECT DAYS
                dayConvention
            );

            periodStart = periodEnd; // move to next cycle

            return {
                ...row,
                interestRate: row.interestRate || iir,
                billAmount,
                periodDays,           // optional (debug/UI)
            };
        });

        setBilledRows(updated);

    }, [
        iir,
        vehicle_cost,
        dayConvention,
        interestOnlyType,
        frequency,
        start_date
    ]);
    // useEffect(() => {
    //     if (interestOnlyType !== "BILL") return;
    //     if (!billedRows.length) return;

    //     const updated = billedRows.map(row => ({
    //         ...row,
    //         interestRate: row.interestRate || iir,
    //         billAmount: calculateInterestAmount(
    //             vehicle_cost,
    //             row.interestRate || iir,
    //             actualInterestDays,
    //             dayConvention
    //         )
    //     }));

    //     setBilledRows(updated);

    // }, [iir, vehicle_cost, dayConvention, interestOnlyType]);


    const decideBillOrCapitalize = (baseDate, actualDate) => {
        if (!baseDate || !actualDate) return "Bill";

        // same day of month → month based → Bill
        if (baseDate.getDate() === actualDate.getDate()) {
            return "BILL";
        }

        // different day → day based → Capitalize
        return "CAPITALIZE";
    };


    useEffect(() => {
        if (interestOnlyType !== "CAPITALIZE") return;

        const interest = calculateInterestAmount(
            vehicle_cost,
            capitalizedInterestRate,
            capitalizeDays,
            dayConvention
        );

        setCapitalizedInterest(interest);
        setTotalLoanAmount(
            (parseFloat(vehicle_cost || 0) + parseFloat(interest)).toFixed(2)
        );

    }, [
        vehicle_cost,
        capitalizedInterestRate,
        capitalizeDays,
        dayConvention,
        interestOnlyType
    ]);
    const calculatePeriodsDiff = (startDate, paymentDate, frequency) => {
        if (!startDate || !paymentDate) return 0;

        const freqMap = {
            Monthly: 1,
            Quarterly: 3,
            "Semi-annual": 6,
            Annual: 12
        };

        const monthsDiff =
            (paymentDate.getFullYear() - startDate.getFullYear()) * 12 +
            (paymentDate.getMonth() - startDate.getMonth());

        return Math.floor(monthsDiff / (freqMap[frequency] || 1));
    };

    // useEffect(() => {
    //     if (!start_date || !paymentstartdate) return;

    //     const periods = calculatePeriodsDiff(
    //         new Date(start_date),
    //         new Date(paymentstartdate),
    //         frequency
    //     );

    //     setInterestOnlyPeriods(periods);

    //     if (periods > 1) {
    //         setIsInterestOnly(true);
    //     } else {
    //         setIsInterestOnly(false);
    //         setInterestOnlyType("");
    //     }

    //     // Capitalize days calculation
    //     if (periods > 1) {
    //         const diffDays = Math.ceil(
    //             (new Date(paymentstartdate) - new Date(start_date)) / (1000 * 60 * 60 * 24)
    //         );
    //         setCapitalizeDays(diffDays);
    //     }

    // }, [start_date, paymentstartdate, frequency]);

    // useEffect(() => {
    //     if (interestOnlyType !== "BILL") return;
    //     if (interestonlypayments <= 0) return;

    //     const rows = [];

    //     for (let i = 1; i <= interestonlypayments; i++) {
    //         rows.push({
    //             period: i,
    //             interestRate: iir,
    //             billAmount: calculateInterestAmount(
    //                 vehicle_cost,
    //                 iir,
    //                 actualInterestDays,
    //                 dayConvention
    //             )
    //         });
    //     }

    //     setBilledRows(rows);
    // }, [interestOnlyType, interestOnlyPeriods,interestonlypayments]);
    // useEffect(() => {
    //     if (interestOnlyType !== "BILL") return;
    //     if (!billedRows.length) return;

    //     const updated = billedRows.map(row => ({
    //         ...row,
    //         interestRate: row.interestRate || iir,
    //         billAmount: calculateInterestAmount(
    //             vehicle_cost,
    //             row.interestRate,
    //             actualInterestDays,
    //             dayConvention
    //         )
    //     }));

    //     setBilledRows(updated);

    // }, [ loanamount, dayConvention, interestOnlyType]);


    const calculateBilledInterest = (principal, rate, dayConvention) => {
        if (!principal || !rate) return 0;

        let days = 30;
        let yearBase = 360;

        if (dayConvention === "Actual/365") {
            yearBase = 365;
        } else if (dayConvention === "Actual/360") {
            yearBase = 360;
        }

        const interest =
            (principal * (rate / 100) * days) / yearBase;

        return interest.toFixed(2);
    };

    const [capitalizedInterest, setCapitalizedInterest] = useState(0);

    useEffect(() => {
        setCapitalizedInterestRate(iir);
    }, [interestOnlyType]);

    const [totalLoanAmount, setTotalLoanAmount] = useState(0);
    const [pmtAmount, setPmtAmount] = useState(0);

    useEffect(() => {

        if (!isInterestOnly || interestOnlyType !== "CAPITALIZE") return;

        const principal = parseFloat(totalLoanAmount || 0);
        const rate = parseFloat(capitalizedInterestRate || 0);
        const term = parseInt(contract_term || 0);

        // if (!principal || !rate || !term) {
        //     setPaymentAmount("0.00");
        //     return;
        // }

        const emi = calculatePMT(
            principal,
            rate,
            term,
            frequency
        );

        setPaymentAmount(emi.toFixed(2));

    }, [
        totalLoanAmount,
        capitalizedInterestRate,
        contract_term,
        frequency,
        dayConvention,
        loanamount
    ]);

    const calculateCapitalizedInterest = () => {
        const divisor = dayConvention === "Actual/365" ? 365 : 360;

        const interest =
            (vehicle_cost * capitalizedInterestRate * capitalizeDays) /
            (divisor * 100);

        setCapitalizedInterest(interest.toFixed(2));

        const total = parseFloat(vehicle_cost) + interest;
        setTotalLoanAmount(total.toFixed(2));
    };
    // Removed duplicate CAPITALIZE recalculation useEffects that used timecountingmethod
    // instead of dayConvention. The correct recalculation is handled by the useEffect at
    // line ~3211 which uses dayConvention (the UI-bound Day Convention dropdown).
    // ----------------------------------
    // Sync default IIR to billed rows
    // ----------------------------------
    // useEffect(() => {
    //     if (!billedRows.length) return;

    //     const updated = billedRows.map(row => ({
    //         ...row,
    //         interestRate: row.interestRate || iir
    //     }));

    //     setBilledRows(updated);
    // }, [iir]);

    // useEffect(() => {
    //     if (!billedRows.length || interestOnlyType !== "BILL") return;

    //     const updated = billedRows.map(row => {
    //         const rate = row.interestRate ?? iir;

    //         let yearBase = 360;
    //         if (row.dayConvention === "Actual/365") yearBase = 365;

    //         const billAmount =
    //             (vehicle_cost * (rate / 100) * 30) / yearBase;

    //         return {
    //             ...row,
    //             interestRate: rate,
    //             billAmount: billAmount.toFixed(2)
    //         };
    //     });

    //     setBilledRows(updated);

    // }, [iir, vehicle_cost, interestOnlyType]);

    // useEffect(() => {
    //     if (!billedRows.length) return;

    //     const updated = billedRows.map(row => ({
    //         ...row,
    //         interestRate: row.interestRate || iir,
    //         // billAmount: calculateBilledInterest(
    //         billAmount: calculateInterestAmount(
    //             vehicle_cost,
    //             row.interestRate,
    //             actualInterestDays,
    //             row.dayConvention
    //         )
    //     }));

    //     setBilledRows(updated);
    // }, [vehicle_cost]);

    // useEffect(() => {
    //     setBilledRows([]);
    // }, [paymentstartdate]);

    // useEffect(() => {
    //     if (!billedRows || billedRows.length === 0) return;
    //     if (!iir) return;

    //     const updated = billedRows.map(row => ({
    //         ...row,
    //         interestRate: iir,
    //         billAmount: calculateBilledInterest(
    //             vehicle_cost,
    //             iir,
    //             row.dayConvention
    //         )
    //     }));

    //     setBilledRows(updated);

    // }, [iir]);

    console.log("interestOnlyType", isInterestOnly);

    const handleSwitchToBill = () => {
        if (!start_date || !paymentstartdate) return;
        const rawBase = getBasePaymentStartDate();
        if (!rawBase) return;
        const basePaymentDate = normalizeDate(rawBase);
        const contractStart = normalizeDate(new Date(start_date));
        const rawActual = paymentstartdate instanceof Date ? paymentstartdate : new Date(paymentstartdate);
        const actualPaymentDate = normalizeDate(rawActual);

        const frequencyMap = { Monthly: 1, Quarterly: 3, "Semi-annual": 6, Annual: 12 };
        const periodMonths = frequencyMap[frequency] || 1;

        // Primary: count full periods between basePaymentDate and actualPaymentDate
        let totalMonths =
            (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
            (actualPaymentDate.getMonth() - basePaymentDate.getMonth());

        // Fallback for CAPITALIZE-pattern dates (different day of month, 0 full base→actual months):
        // count periods from contract start to payment start instead
        if (totalMonths <= 0 || totalMonths % periodMonths !== 0) {
            const fromStart =
                (actualPaymentDate.getFullYear() - contractStart.getFullYear()) * 12 +
                (actualPaymentDate.getMonth() - contractStart.getMonth());
            totalMonths = Math.floor(fromStart / periodMonths) * periodMonths;
        }

        if (totalMonths > 0) {
            const billPeriods = totalMonths / periodMonths;
            const rows = [];
            let periodStart = normalizeDate(new Date(start_date));
            for (let i = 0; i < billPeriods; i++) {
                const periodEnd = addMonthsSafe(periodStart, periodMonths);
                const periodDays = daysBetween(periodStart, periodEnd);
                rows.push({
                    period: i + 1,
                    periodDays,
                    interestRate: iir,
                    dayConvention: dayConvention,
                    billAmount: calculateInterestAmount(vehicle_cost, iir, periodDays, dayConvention),
                });
                periodStart = periodEnd;
            }
            setBilledRows(rows);
            setInterestOnlyPayments(billPeriods);
        }
        setInterestOnlyType("BILL");
    };

    const handleSwitchToCapitalize = () => {
        if (!start_date || !paymentstartdate) return;
        const contractStart = normalizeDate(new Date(start_date));
        const paymentStart = normalizeDate(
            paymentstartdate instanceof Date ? paymentstartdate : new Date(paymentstartdate)
        );
        const frequencyMap = { Monthly: 1, Quarterly: 3, "Semi-annual": 6, Annual: 12 };
        const cycleMonths = frequencyMap[frequency] || 1;

        const accrualStart = normalizeDate(
            new Date(
                paymentStart.getFullYear(),
                paymentStart.getMonth() - cycleMonths,
                paymentStart.getDate()
            )
        );

        let days = 0;
        if (accrualStart >= contractStart) {
            days = calculateCalendarDays(contractStart, accrualStart);
        } else if (accrualStart < contractStart) {
            const calcEndDate = new Date(paymentStart);
            calcEndDate.setDate(calcEndDate.getDate() - 1);
            const forwardDays = calculateCalendarDays(contractStart, calcEndDate);
            days = -(30 - forwardDays);
        } else {
            days = calculateCalendarDays(contractStart, accrualStart);
        }

        let yearBase = 360;
        if (dayConvention === "Actual/365") yearBase = 365;
        const principal = parseFloat(loanamount || vehicle_cost || 0);
        const rate = parseFloat(iir || 0);
        const creditInterest = (principal * rate * days) / (100 * yearBase);
        const newPrincipal = principal + creditInterest;

        setCapitalizeDays(days);
        setCapitalizedInterestRate(rate);
        setCapitalizedInterest(creditInterest.toFixed(2));
        setTotalLoanAmount(newPrincipal.toFixed(2));
        setInterestOnlyPayments(days);
        const emi = calculatePMT(newPrincipal, rate, parseInt(contract_term || 0), frequency);
        setPaymentAmount(emi.toFixed(2));
        setInterestOnlyType("CAPITALIZE");
    };

    const saveInterestOnlyAfterContract = async (contractId) => {
        if (!isInterestOnly || !interestOnlyType) return;

        let payload = {
            contract: contractId,
            interest_only_type: interestOnlyType,
            company: companydata?.id
        };

        // ---------------- BILL ----------------
        if (interestOnlyType === "BILL") {
            payload.rows = billedRows.map(row => ({
                period_no: row.period,
                interest_rate: row.interestRate,
                day_convention: row.dayConvention,
                bill_amount: row.billAmount
            }));
        }

        // ---------------- CAPITALIZE ----------------
        if (interestOnlyType === "CAPITALIZE") {
            // payload.interest_rate = capitalizedInterestRate;
            // payload.day_convention = dayConvention;
            // payload.capitalize_interest_days = capitalizeDays;
            // payload.loan_principal = vehicle_cost + capitalizedInterest;
            // payload.capitalized_interest = capitalizedInterest;
            // payload.total_loan_amount = totalLoanAmount;
            payload.rows = [
                {
                    period_no: 1,
                    interest_rate: capitalizedInterestRate,
                    day_convention: dayConvention,
                    capitalize_interest_days: capitalizeDays,
                    loan_principal: vehicle_cost,
                    capitalized_interest: capitalizedInterest,
                    total_loan_amount: totalLoanAmount,
                    payment_amount: paymentAmount || 0
                }
            ];
        }

        try {
            await axios.post(
                `${API}contracts/interest-only/bulk-create/`,
                payload,
                { headers: authHeader() }
            );
            if (interestOnlyType === "CAPITALIZE") {
                handlepayment(contractId);
            }


        } catch (error) {
            console.error("Interest Only Save Failed", error);
            toast.error("Interest Only Period save failed");
        }
    };


    // const calculatePMT = (principal, annualRate, termMonths) => {
    //   if (!principal || !annualRate || !termMonths) return 0;

    //   const monthlyRate = annualRate / 100 / 12;

    //   if (monthlyRate === 0) {
    //     return principal / termMonths;
    //   }

    //   const pmt =
    //     (principal *
    //       monthlyRate *
    //       Math.pow(1 + monthlyRate, termMonths)) /
    //     (Math.pow(1 + monthlyRate, termMonths) - 1);

    //   return pmt;
    // };
    const calculatePMT = (principal, annualRate, term, payfrequency) => {
        // term = contract_term in MONTHS
        if (!principal || !term) return 0;

        const frequencyMap = {
            Monthly: 12,
            Quarterly: 4,
            "Semi-annual": 2,
            Annual: 1,
        };

        const periodsPerYear = frequencyMap[payfrequency] || 12;

        // ✅ number of total payment periods
        const totalPeriods = term / (12 / periodsPerYear);

        if (totalPeriods === 0) return 0;

        // ✅ periodic interest rate
        const periodicRate = (annualRate || 0) / 100 / periodsPerYear;

        // ✅ If interest rate = 0
        if (periodicRate === 0) {
            return Number((principal / totalPeriods).toFixed(6));
        }

        // ✅ Standard PMT formula (clean version)
        const pmt =
            (principal * periodicRate) /
            (1 - Math.pow(1 + periodicRate, -totalPeriods));

        return Number(pmt.toFixed(6));
    };

    const [termsList, setTermsList] = useState([]); // API data
    const [selectedTermName, setSelectedTermName] = useState("");
    const [selectedTermValue, setSelectedTermValue] = useState("");
    const [contractTerms, setContractTerms] = useState([]);


    const fetchTerms = async () => {
        try {
            const res = await axios.get(
                `${API}company/term-conditions/`,
                { headers: authHeader() }
            );
            setTermsList(res.data);
        } catch {
            toast.error("Failed to load terms");
        }
    };

    useEffect(() => {
        fetchTerms();
    }, []);

    const handleTermsChange = (name) => {
        setSelectedTermName(name);

        const term = termsList.find((t) => t.name === name);
        setSelectedTermValue(term?.value || "");
    };

    const addTerm = () => {
        if (!selectedTermName) {
            toast.error("Please select term");
            return;
        }

        const newTerm = {
            name: selectedTermName,
            value: selectedTermValue,
        };

        setContractTerms([...contractTerms, newTerm]);

        // reset
        setSelectedTermName("");
        setSelectedTermValue("");
    };

    const deleteTerm = (index) => {
        const updated = [...contractTerms];
        updated.splice(index, 1);
        setContractTerms(updated);
    };


    useEffect(() => {
        if (interestRateType === "Floating") {
            const totalRate = parseFloat(baseRate || 0) + parseFloat(margin || 0);
            setIir(totalRate);
        }
    }, [baseRate, margin, interestRateType]);



    return (
        <div className="contract-form-container">
            <ToastContainer />
            <div className="row g-4">
                <CreateAddress state2={state2} setState2={setState2} handleSubmit3={handleSubmit3} handleAddressforInstall={handleAddressforInstall}
                    form3={form3} installaddress_line_1={installaddress_line_1} register3={register3} setInstallAddress_line_1={setInstallAddress_line_1}
                    errors3={errors3} setInstallAddress_line_2={setInstallAddress_line_2} installaddress_line_2={installaddress_line_2} installcountryid={installcountryid}
                    handlecountryInstall={handlecountryInstall} country_name={country_name} install_stateaddressId={install_stateaddressId} handlestateInstall={handlestateInstall}
                    install_state_name={install_state_name} installcity={installcity} setInstallCity={setInstallCity} installzip_code={installzip_code} setInstallZip_code={setInstallZip_code}
                    checkBtn3={checkBtn3}
                />
                <AddCutomer state1={state1} setState1={setState1}
                    handleSubmit2={handleSubmit2} party_type={party_type}
                    handlepartydefault={handlepartydefault} setParty_type={setParty_type}
                    form2={form2} customer_type={customer_type} register2={register2} handleshowhide={handleshowhide}
                    errors2={errors2} customer_name={customer_name} setCustomer_name={setCustomer_name} address_line_1={address_line_1}
                    setAddress_line_1={setAddress_line_1} countryid={countryid} country_name={country_name} handlecountry={handlecountry}
                    stateaddressId={stateaddressId} state_name={state_name} handlestate={handlestate} city={city} setCity={setCity} zip_code={zip_code}
                    setZip_code={setZip_code} checkBtn2={checkBtn2} setAddress_line_2={setAddress_line_2} address_line_2={address_line_2}
                />
                <FilterAsset state6={state6} setState6={setState6} itemSelect={itemSelect} loadOptionItem={loadOptionItem} handelInputChangeItem={handelInputChangeItem}
                    handelChangeItem={handelChangeItem} selectSerial={selectSerial} loadOptionsserial={loadOptionsserial} handelInputChangeSerial={handelInputChangeSerial}
                    handelChangeserial={handelChangeserial} selectModel={selectModel} loadOptionsModel={loadOptionsModel} handelInputChangeModel={handelInputChangeModel}
                    handelChangemodel={handelChangemodel} selectMake={selectMake} loadOptionsMake={loadOptionsMake} handelInputChangeMake={handelInputChangeMake} handelChangeMake={handelChangeMake}
                    selectManu={selectManu} loadOptionsManu={loadOptionsManu} handelInputChangeManu={handelInputChangeManu} handelChangeManu={handelChangeManu} handleClear={handleClear}
                    handelSearch={handelSearch} item_master_id={item_master_id} handleTagClick={handleTagClick} inventory_option={inventory_option}
                />
                <AddAsset state3={state3} setState3={setState3} isEquipment={isEquipment} handleSubmit5={handleSubmit5}
                    handlePartyAsset={handlePartyAsset} form5={form5} asset_number={asset_number} register5={register5}
                    setAsset_number={setAsset_number} make={make} setMake={setMake} model={model} setModel={setModel}
                    manufacturer={manufacturer} setManufacturer={setManufacturer} residal_value={residal_value} setResidal_value={seTresidal_value}
                    in_service_date={in_service_date} setIn_service_date={setIn_service_date} checkBtn5={checkBtn5} handlevin={handlevin}
                    vin_number={vin_number} setVin_number={setVin_number} year={year} setYear={setYear} milage={milage} setMilage={setMilage}
                />
                <AddVendor state4={state4} setState4={setState4} handleSubmit4={handleSubmit4} handlepartyvendor={handlepartyvendor} form4={form4}
                    party_typevendor={party_typevendor} setParty_typeVendor={setParty_typeVendor} customer_typevendor={customer_typevendor} register4={register4}
                    handleshowhidevendor={handleshowhidevendor} errors4={errors4} customer_namevendor={customer_namevendor} setCustomer_nameVendor={setCustomer_nameVendor} vendoraddress_line_1={vendoraddress_line_1}
                    setVendorAddress_line_1={setVendorAddress_line_1} setVendorAddress_line_2={setVendorAddress_line_2} vendoraddress_line_2={vendoraddress_line_2}
                    vendorcountryid={vendorcountryid} handlecountryVendor={handlecountryVendor} vendor_country_name={vendor_country_name} venderstateaddressId={venderstateaddressId}
                    handlestateVender={handlestateVender} vendor_state_name={vendor_state_name} vendorcity={vendorcity} setVendorCity={setVendorCity} vendorzip_code={vendorzip_code}
                    setVendorZip_code={setVendorZip_code} checkBtn4={checkBtn4}
                />
                <div className="col-lg-8 col-md-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white border-bottom-0 py-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">{t("Create Contract Loan")}</h5>
                                <span className="badge bg-light text-dark">Step {currentStep} of {totalSteps}</span>
                            </div>
                            <div className="progress mt-3" style={{ height: "4px" }}>
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                                    aria-valuenow={currentStep}
                                    aria-valuemin="0"
                                    aria-valuemax={totalSteps}
                                ></div>
                            </div>
                        </div>
                        <div className="card-body py-4">
                            <Form
                                role="form text-left"
                                onSubmit={(e) => {
                                    if (currentStep < totalSteps) {
                                        e.preventDefault();
                                        return;
                                    }

                                    handleSubmit(handleRegister)(e);
                                }}
                                onKeyDown={handleFormKeyDown}
                                ref={form}
                                action="."
                                method="POST"
                                id="addPartyForm"
                                className="contract-form-body"
                            >
                                {currentStep === 1 && (
                                    <div className="form-section">
                                        <h2 className="section-title">{t("Basic Information")}</h2>

                                        <div className="row mb-4">

                                            <div className="col-md-6">
                                                <label className="col-form-label">{t("Sub Company")} <Tooltip content={t("Subcompany_Tooltip")}>
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                </Tooltip></label>
                                                <select
                                                    className="form-select"
                                                    // value={subcompany}
                                                    name="subcompany"
                                                    // onChange={(e) => {
                                                    //   setSubcompany(e.target.value);
                                                    //   setValue("subcompany", e.target.value);
                                                    // }}
                                                    {...register("subcompany", {
                                                        onChange: (e) => {
                                                            setSubcompany(e.target.value);
                                                            setValue("subcompany", e.target.value)
                                                        },
                                                        required: false,
                                                    })}
                                                >
                                                    <option value="">Select Company</option>
                                                    {subcompanyOptions.map((sub) => (
                                                        <option key={sub.id} value={sub.id}>
                                                            {sub.sub_company_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="col-form-label">{t("Line of Business")} <Tooltip content={t("Lineofbusiness_Tooltip")}>
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                </Tooltip></label>
                                                <select
                                                    className="form-select"
                                                    // value={lineOfBusiness}
                                                    name="lineOfBusiness"
                                                    {...register("lineOfBusiness", {
                                                        onChange: (e) => {
                                                            setLineOfBusiness(e.target.value);
                                                            setValue("lineOfBusiness", e.target.value);
                                                        },
                                                        required: false,
                                                    })}
                                                >
                                                    <option value="">Select Line of Business</option>
                                                    {lineOfBusinessOptions.map((lob) => (
                                                        <option key={lob.id} value={lob.id}>
                                                            {lob.lob_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label required">
                                                    {t("Contract Number")}{" "}
                                                    <Tooltip content={t("Contract_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    disabled={
                                                        contract_number_method_disable === "Automatic"
                                                            ? true
                                                            : false
                                                    }
                                                    onChange={(e) =>
                                                        setContract_number(e.target.value)
                                                    }
                                                    type="text"
                                                    className='form-control'
                                                    name="contract_number"
                                                    id="contract_number"
                                                    {...register("contract_number", {
                                                        onChange: (e) => {
                                                            setContract_number(e.target.value);
                                                        },
                                                        required:
                                                            contract_number_method_disable ===
                                                                "Automatic"
                                                                ? false
                                                                // : true,
                                                                : "Contract number is required",
                                                    })}
                                                />
                                                <div className="invalid-feedback">
                                                    {errors.contract_number && errors.contract_number.message}
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label">
                                                    {t("Description")}
                                                </label>
                                                <input
                                                    onChange={(e) =>
                                                        setDescription(e.target.value)
                                                    }
                                                    type="text"
                                                    className='form-control'
                                                    name="contract_description"
                                                    id="contract_description"
                                                    value={description}
                                                />
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <label className="col-form-label required">
                                                    {t("Customer")}{" "}
                                                    <Tooltip content={t("Customer_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                {/* <div className="input-group"> */}
                                                <div className="col-lg-12">
                                                    <AsyncSelect
                                                        {...register("selectedValue", {
                                                            required: "Customer is required",
                                                        })}
                                                        defaultOptions={options}
                                                        isClearable
                                                        placeholder={t("Search for Customer(%for All)")}
                                                        options={options}
                                                        value={options.find(
                                                            (option) => option.id === selectedValue
                                                        )}
                                                        getOptionLabel={(e) => e.customer_name}
                                                        getOptionValue={(e) => e.customer_name}
                                                        loadOptions={loadOptions}
                                                        onInputChange={handelInputChange}
                                                        onChange={handelChange}
                                                        name="selectedValue"
                                                    ></AsyncSelect>

                                                    <div className="invalid-feedback">
                                                        {(!selectedValue && errors.selectedValue) && errors.selectedValue.message}
                                                    </div>
                                                </div>
                                                <button type="button" className="btn-link add-new-link"
                                                    // onClick={() => setState1({ isPaneOpen: true })}
                                                    onClick={() => { setAddCustomerSource('step1'); setState1({ isPaneOpen: true }); }}
                                                >
                                                    <Plus className="btn-icon-small" />
                                                    Add New Customer
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <label className="col-form-label required">
                                                    {t("Bill to Address")}{" "}
                                                    <Tooltip content={t("BilltoAddress_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                    <AsyncSelect
                                                        {...register("billto", {
                                                            required: "Address is required",
                                                        })}
                                                        name="billto"
                                                        cacheOptions
                                                        defaultOptions={filterBill}
                                                        isClearable
                                                        isSearchable
                                                        options={filterBill}
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => option.value}
                                                        onChange={handleBillAddressChange}
                                                        loadOptions={loadOptionBillAdd}
                                                        value={filterBill.find((val) => val.value === address_id)}
                                                        placeholder={`${t("Search Address")}`}
                                                    />
                                                    <div className="invalid-feedback">
                                                        {(!address_id && errors.billto) && errors.billto.message}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <label className="col-form-label required">
                                                    {t("Collateral Location")}{" "}
                                                    <Tooltip content={t("InstallAddress_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                    <AsyncSelect
                                                        {...register("address_id", {
                                                            required: "Collateral Location is required",
                                                        })}
                                                        name="address_id"
                                                        cacheOptions
                                                        defaultOptions={filteredOptions}
                                                        isClearable
                                                        isSearchable
                                                        options={filteredOptions}
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => option.value}
                                                        onChange={handleAddressChange}
                                                        loadOptions={loadOptionInstallAdd}
                                                        value={filteredOptions.find((val) => val.value === reg_address1)}
                                                        placeholder={`${t("Search Install Address")}`}
                                                    />
                                                    <div className="invalid-feedback">
                                                        {(!reg_address1 && errors.address_id) && errors.address_id.message}
                                                    </div>
                                                </div>
                                                <button type="button" className="btn-link add-new-link"
                                                    onClick={() => setState2({ isPaneOpen: true })}
                                                >
                                                    <Plus className="btn-icon-small" />
                                                    Add New Location
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label required">
                                                    {t("Contract Start Date")}{" "}
                                                    <Tooltip content={t("StartDate_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                    <DatePicker
                                                        {...register("startdate", { required: "Contract Start Date  is required" })}
                                                        className="form-control datepick"
                                                        selected={start_date}
                                                        onChange={(e) => handelStart_Date(e)}
                                                        name="startdate"
                                                        placeholderText={"mm/dd/yyyy"}
                                                        showYearDropdown // year show and scrolldown alos
                                                        scrollableYearDropdown
                                                        showMonthDropdown
                                                        dropdownMode="select"
                                                    />
                                                    <div className="invalid-feedback">
                                                        {errors.startdate && errors.startdate.message}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="col-form-label required">
                                                    {t("Term")}{" "}
                                                    <Tooltip content={t("Term_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contract_term"
                                                    id="contract_term"
                                                    value={contract_term}
                                                    {...register("contract_term", {
                                                        required: "Term is required",
                                                        max: {
                                                            value: free.length !== 0 ? free[0].contract_term : 72,
                                                            // message: `Term should not be more than ${free.length !== 0 ? free[0].contract_term : 60} for this user plan`,
                                                            message: `Maximum term is 72 months. Please enter a term between 1 and 72.`,
                                                        },
                                                        validate: {
                                                            positiveWholeNumber: (value) => {
                                                                const numberValue = Number(value);
                                                                if (isNaN(numberValue)) {
                                                                    return "Only numbers are allowed";
                                                                } else if (numberValue % 1 !== 0) {
                                                                    return "Decimal numbers are not allowed";
                                                                }
                                                                else if (!Number.isInteger(numberValue) || numberValue <= 0) {
                                                                    return "Only positive numbers are allowed";
                                                                }
                                                                return true;
                                                            }
                                                        },
                                                        onChange: (e) => {
                                                            handelContract_term(e.target.value);
                                                        },
                                                    })}
                                                />
                                                <div className="invalid-feedback">
                                                    {errors.contract_term &&
                                                        errors.contract_term.message}
                                                </div>
                                            </div>
                                            {/* </div> */}
                                            {/* <div className="col-md-6">
                                                                  <label className="col-form-label">{t("Application Originator")} <Tooltip content={t("ApplicationOrginator_Tooltip")}>
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                  </Tooltip></label>
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={appOriginator}
                                                                    name="appOriginator"
                                                                    placeholder="Enter Application Originator"
                                                                    {...register("appOriginator", {
                                                                      onChange:(e) => {
                                                                        setAppOriginator(e.target.value);
                                                                        setValue("appOriginator", e.target.value);
                                                                      },
                                                                      required: false,
                                                                    })}
                                                                  />
                                                                  {errors.appOriginator && (
                                                                    <div className="text-danger">
                                                                      {errors.appOriginator.message}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                                <div className="col-md-6">
                                                                  <label className="col-form-label">{t("Source")} <Tooltip content={t("Source_Tooltip")}>
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                  </Tooltip></label>
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={source}
                                                                    name="source"
                                                                    placeholder="Enter Source"
                                                                    {...register("source", {
                                                                      onChange:(e) => {
                                                                        setSource(e.target.value);
                                                                        setValue("source", e.target.value);
                                                                      },
                                                                      required: false,
                                                                    })}
                                                                  />
                                                                  {errors.source && (
                                                                    <div className="text-danger">
                                                                      {errors.source.message}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                                  */}
                                            <div className="col-md-6">
                                                <label className="col-form-label">{t("Sales Representative")} <Tooltip content={t("SalesRep_Tooltip")}>
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                </Tooltip></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={salesRep}
                                                    name="salesRep"
                                                    placeholder="Enter Sales Representative"
                                                    {...register("salesRep", {
                                                        onChange: (e) => {
                                                            setSalesRep(e.target.value);
                                                            setValue("salesRep", e.target.value);
                                                        },
                                                        required: false,
                                                    })}
                                                />
                                                {errors.salesRep && (
                                                    <div className="text-danger">
                                                        {errors.salesRep.message}
                                                    </div>
                                                )}
                                            </div>




                                        </div>
                                    </div>
                                )}

                                {currentStep === 2 && (
                                    <div className="form-section">
                                        <h2 className="section-title">Asset Details</h2>

                                        <div className="row mb-4">
                                            <div className="col-md-6">
                                                <label className="col-form-label required">
                                                    {t("Vendor Name")}{" "}
                                                    <Tooltip content={t("VendorName_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <AsyncSelect
                                                    {...register("vendorname1", {
                                                        required: "Vendor is required",
                                                    })}
                                                    name="vendorname1"
                                                    cacheOptions
                                                    defaultOptions={filteredVendor}
                                                    isClearable
                                                    isSearchable
                                                    options={filteredVendor}
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionValue={(option) => option.value}
                                                    onChange={handleVendorChange}
                                                    loadOptions={loadOptionVendorName}
                                                    value={filteredVendor.find((val) => val.value === vendername1)}
                                                    placeholder={`${t("Search Vendor Name")}`}
                                                />
                                                <div className="invalid-feedback">
                                                    {(!vendername1 && errors.vendorname1) && errors.vendorname1.message}
                                                </div>
                                                <button type="button" className="btn-link add-new-link"
                                                    onClick={() => setState4({ isPaneOpen: true })}
                                                >
                                                    <Plus className="btn-icon-small" />
                                                    Add New Vendor
                                                </button>
                                            </div>
                                            {
                                                asset_type.length === 1 ?
                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        {/* <label className="col-lg-6 col-form-label text-left required">{t("Asset Type")} <Tooltip content={t("AssetType_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label> */}
                                                        <label className="col-lg-6 col-form-label text-left required">{t("Collateral Type")} <Tooltip content={t("CollateralType_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                        <input type="text"
                                                            disabled
                                                            className="form-control"
                                                            value={asset_typesetting}
                                                        />
                                                    </div>
                                                    :
                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        {/* <label className="col-lg-6 col-form-label text-left required">{t("Asset Type")} <Tooltip content={t("AssetType_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label> */}
                                                        <label className="col-lg-6 col-form-label text-left required">{t("Collateral Type")} <Tooltip content={t("CollateralType_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                        <select
                                                            id="frequency"
                                                            className="form-control"
                                                            name="assettype"
                                                            value={asset_typeselection}
                                                            {...register("assettype", {
                                                                onChange: (e) => {
                                                                    handleAssetType(e.target.value)
                                                                },
                                                                required: "Asset Type is required",
                                                            })}
                                                        >
                                                            <option value="">{("Select Asset Type")}</option>
                                                            <option value="Vehicle">{t("Vehicle")}</option>
                                                            <option value="Equipment">{t("Equipment")}</option>
                                                        </select>
                                                        <div className="invalid-feedback">
                                                            {errors.assettype && errors.assettype.message}
                                                        </div>
                                                    </div>

                                            }
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label required">
                                                    {t("Asset Cost")}{" "}

                                                    <Tooltip content={t("VehicleCost_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="input-group">
                                                    <span className="input-group-text" style={{ height: '35px' }}>$</span>
                                                    <CurrencyInput
                                                        id="input-example"
                                                        className="form-control"
                                                        {...register("vehiclecost", {
                                                            required: "Loan is required",
                                                            validate: {
                                                                positive: (v) =>
                                                                    parseInt(v) > 0 || "Only positive numbers are allowed",
                                                            },
                                                        })}
                                                        allowDecimals="false"
                                                        value={vehicle_cost}
                                                        onValueChange={(value) => hanldevehiclecost(value)}
                                                        name="vehiclecost"
                                                        disableAbbreviations
                                                    />
                                                </div>
                                                <div className="invalid-feedback">
                                                    {errors.vehiclecost && errors.vehiclecost.message}
                                                </div>
                                            </div>
                                            <div className="col-md-6 position-relative">
                                                <label className="col-form-label required">
                                                    {t("Asset Description")}{" "}
                                                    <Tooltip content={t("AssetDesc_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        placeholder={t("Asset Description")}
                                                        className="form-control"
                                                        type="text"
                                                        name="asset_desc"
                                                        maxLength="200"
                                                        id="asset_desc"
                                                        value={asset_desc}
                                                        {...register("asset_desc", {
                                                            onChange: (e) => {
                                                                handleDescription(e.target.value)
                                                            },
                                                            required: true,
                                                        })}
                                                    />
                                                    <span className="input-group-text">
                                                        <Search className="search-icon"
                                                            onClick={handleExitingInventory} />
                                                    </span>
                                                    <div className="invalid-feedback">
                                                        {errors.asset_desc?.type === "required" &&
                                                            "Asset description is required"}
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-link add-new-link ms-3"
                                                    onClick={() => { setState3({ isPaneOpen: true }) }}

                                                >
                                                    <Plus className="btn-icon-small me-1" />
                                                    Add New Asset
                                                </button>
                                            </div>
                                            {/* <div className="form-group row"> */}
                                            <div className="col-sm-6 position-relative">
                                                <label className="col-form-label ">{t('Category')} <Tooltip content={t('Category_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <select
                                                    className="form-control"
                                                    name="category"
                                                    // onChange={(e)=>{handleCategoryChange(e)}}
                                                    {...register("category", { onChange: (e) => { handleCategoryChange(e) }, required: false })}
                                                    value={selected_category}
                                                >
                                                    <option value="">Select Category</option>
                                                    {category_list.map((val, i) => (
                                                        <option key={i} value={val.id}>
                                                            {val.category_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="invalid-feedback">
                                                    {errors.category?.type === 'required' && "Category  is required"}
                                                </div>
                                            </div>
                                            <div className="col-sm-6 position-relative">
                                                <label className="col-form-label ">{t('Sub Category')} <Tooltip content={t('Sub_category_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <select
                                                    className="form-control"
                                                    name="subcategory"
                                                    value={selected_sub_category}
                                                    {...register("subcategory", { onChange: (e) => { handlesubCategoryChange(e) }, required: false })}
                                                >
                                                    <option value="">Select Subcategory</option>
                                                    {sub_categories.map((val) => (
                                                        <option key={val.id} value={val.id}>
                                                            {val.sub_category_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="invalid-feedback">
                                                    {errors.subcategory?.type === 'required' && "Subcategory  is required"}
                                                </div>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                )}

                                {currentStep === 3 && (
                                    <div className="form-section">
                                        <h2 className="section-title">Payment Details</h2>

                                        <div className="row mb-4">
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label required">
                                                    {t("Loan Amount")}{" "}

                                                    <Tooltip content={t("VehicleCost_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="input-group">
                                                    <span className="input-group-text" style={{ height: '35px' }}>$</span>
                                                    <CurrencyInput
                                                        id="input-example"
                                                        className="form-control"
                                                        {...register("vehiclecost", {
                                                            required: "Loan is required",
                                                            validate: {
                                                                positive: (v) =>
                                                                    parseInt(v) > 0 || "Only positive numbers are allowed",
                                                            },
                                                        })}
                                                        allowDecimals="false"
                                                        value={vehicle_cost}
                                                        onValueChange={(value) => hanldevehiclecost(value)}
                                                        name="vehiclecost"
                                                        disableAbbreviations
                                                    />
                                                </div>
                                                <div className="invalid-feedback">
                                                    {errors.vehiclecost && errors.vehiclecost.message}
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label ">{t("Interest Rate Type")}{" "}
                                                    <Tooltip content={t("InterestRateType_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="form-group row">

                                                    <div className="col-12 col-md-6">
                                                        <div className=" form-check">
                                                            <input
                                                                className="form-check-input"

                                                                type="radio"
                                                                name="interestRateType"
                                                                value="Fixed"
                                                                checked={interestRateType === "Fixed"}
                                                                onChange={(e) => setInterestRateType(e.target.value)}
                                                            />
                                                            <label className="form-check-label">
                                                                Fixed
                                                            </label>
                                                        </div>
                                                    </div>


                                                    <div className="col-12 col-md-6">

                                                        <div className="form-check"
                                                            style={{
                                                                opacity: isFloatingDisabled ? 0.6 : 1,
                                                                cursor: isFloatingDisabled ? 'not-allowed' : 'default'
                                                            }}
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="interestRateType"
                                                                value="Floating"
                                                                checked={interestRateType === "Floating"}
                                                                disabled={isFloatingDisabled}
                                                                onChange={(e) => setInterestRateType(e.target.value)}
                                                                style={{ cursor: isFloatingDisabled ? 'not-allowed' : 'pointer' }}
                                                            />
                                                            <label className="form-check-label"
                                                                style={{ color: isFloatingDisabled ? '#9E9E9E' : 'inherit' }}
                                                            >
                                                                Floating {isFloatingDisabled && <span title="Premium Feature">🔒</span>}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* <select
                                                    className="form-control"
                                                    value={interestRateType}
                                                    onChange={(e) => setInterestRateType(e.target.value)}
                                                >
                                                    <option value="Fixed">Fixed</option>
                                                    <option value="Floating">Floating</option>
                                                </select> */}

                                            </div>
                                            {interestRateType === "Floating" && (
                                                <>
                                                    <div className="col-md-6 mb-3 mb-md-0">
                                                        <label className="col-lg-12 col-form-label">{t("Base Rate")}{" "}
                                                            <Tooltip content={t("BaseRate_Tooltip")}>
                                                                <i className="fa fa-light fa-circle-info"></i>
                                                            </Tooltip>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={baseRate}
                                                            onChange={(e) => setBaseRate(e.target.value)}
                                                            onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                                            onKeyDown={(e) => {
                                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                                    e.preventDefault();              // ✅ disables up/down arrow change
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3 mb-md-0">
                                                        <label className="col-lg-12 col-form-label">{t("Margin")}{" "}
                                                            <Tooltip content={t("Margin_Tooltip")}>
                                                                <i className="fa fa-light fa-circle-info"></i>
                                                            </Tooltip>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={margin}
                                                            onChange={(e) => setMargin(e.target.value)}
                                                            onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                                            onKeyDown={(e) => {
                                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                                    e.preventDefault();              // ✅ disables up/down arrow change
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-lg-12 col-form-label required">
                                                    {t("Interest Rate")}{" "}
                                                    <Tooltip content={t("InterestRate_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                    <input
                                                        type="number"
                                                        step="0.00000001"
                                                        id="interest"
                                                        name="interest"
                                                        value={iir}
                                                        className="form-control no-spinner"
                                                        disabled={interestRateType === "Floating"}
                                                        {...register("interest", {
                                                            validate: {
                                                                positive: (v) =>
                                                                    parseFloat(v) >= 0 || "Enter Interest Rate Positive Value",
                                                            },
                                                            onChange: (e) => { setIir(e.target.value) },
                                                            required: 'Interest Rate is required'
                                                        })}
                                                        onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                                        onKeyDown={(e) => {
                                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                                e.preventDefault();              // ✅ disables up/down arrow change
                                                            }
                                                        }}
                                                    />
                                                    <div className="invalid-feedback">
                                                        {errors.interest?.message}
                                                    </div>
                                                </div>
                                            </div>


                                            {/* </div> */}
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-md-6 mb-3 mb-md-0">

                                                <label className="col-form-label required">
                                                    {t("Payment Start Date")}{" "}
                                                    <Tooltip content={t("PaymentStartDate_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                {/* <input className="form-control "
                                                    value={Helper.DateNormal(paymentstartdate)}
                                                    disabled
                                                /> */}
                                                <div className="col-lg-12">
                                                    <DatePicker
                                                        {...register("paymentstartdate", {
                                                            required: true,
                                                        })}
                                                        className="form-control datepick"
                                                        // value={Helper.DateNormal(paymentstartdate)}
                                                        selected={
                                                            paymentstartdate
                                                            // ? new Date(paymentstartdate)
                                                            // : ""
                                                        }
                                                        onChange={(value) =>
                                                            Paymentstartdate(value)
                                                        }
                                                        name="paymentstartdate"
                                                        placeholderText={"mm/dd/yyyy"}
                                                        // disabled
                                                        showYearDropdown // year show and scrolldown alos
                                                        scrollableYearDropdown
                                                        showMonthDropdown
                                                        dropdownMode="select"
                                                    />
                                                    <div className="invalid-feedback">
                                                        {errors.paymentstartdate &&
                                                            "Payment Start Date  is required"}
                                                    </div>
                                                </div>

                                                {/* <label className="col-lg-12 col-form-label ">
                                                    {t("Interest Only Payments")}{" "}
                                                    <Tooltip content={t("InterestOnlyPayments_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                    <input
                                                        type="number"
                                                        step="0.00000001"
                                                        id="interestonlypayments"
                                                        name="interestonlypayments"
                                                        value={interestonlypayments}
                                                        className="form-control no-spinner"
                                                        {...register("interestonlypayments", {
                                                            validate: {
                                                                positive: (v) =>
                                                                    parseInt(v) >= 0 || "Enter Interest only payments Positive Value",
                                                            },
                                                            onChange: (e) => { setInterestOnlyPayments(e.target.value) },
                                                            // required: 'Interest Only Payments is required'
                                                            required: false
                                                        })}
                                                        onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                                        onKeyDown={(e) => {
                                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                            e.preventDefault();              // ✅ disables up/down arrow change
                                                            }   
                                                        }}
                                                    />
                                                    <div className="invalid-feedback">
                                                        {errors.interestonlypayments?.message}
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label required">
                                                    {t("Frequency")}{" "}
                                                    <Tooltip content={t("Frequency_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <select
                                                    id="frequency"
                                                    className="form-control"
                                                    name="frequency"
                                                    value={frequency}
                                                    {...register("frequency", {
                                                        onChange: (e) => {
                                                            setFrequency(e.target.value);
                                                        },
                                                        required: true,
                                                    })}
                                                >
                                                    <option value="">{t("Select Frequency")}</option>
                                                    <option value="Monthly">{t("Monthly")}</option>
                                                    <option value="Quarterly">
                                                        {t("Quarterly")}
                                                    </option>
                                                    <option value="Semi-annual">
                                                        {t("Semi-annual")}
                                                    </option>
                                                    <option value="Annual">{t("Annual")}</option>
                                                </select>
                                                <div className="invalid-feedback">
                                                    {errors.frequency && "Frequency is required"}
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                {/* <label className="col-form-label required">
                                                    {t("Payment Start Date")}{" "}
                                                    <Tooltip content={t("PaymentStartDate_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label> */}
                                                {/* <input className="form-control "
                                                    value={Helper.DateNormal(paymentstartdate)}
                                                    disabled
                                                /> */}
                                                {/* <div className="col-lg-12">
                                                    <DatePicker
                                                        {...register("paymentstartdate", {
                                                        required: true,
                                                        })}
                                                        className="form-control datepick"
                                                        // value={Helper.DateNormal(paymentstartdate)}
                                                        selected={
                                                        paymentstartdate
                                                            // ? new Date(paymentstartdate)
                                                            // : ""
                                                        }
                                                        onChange={(value) =>
                                                        Paymentstartdate(value)
                                                        }
                                                        name="paymentstartdate"
                                                        placeholderText={"mm/dd/yyyy"}
                                                        // disabled
                                                        showYearDropdown // year show and scrolldown alos
                                                        scrollableYearDropdown
                                                        showMonthDropdown
                                                        dropdownMode="select"
                                                    />
                                                    <div className="invalid-feedback">
                                                        {errors.paymentstartdate &&
                                                        "Payment Start Date  is required"}
                                                    </div> */}
                                                {/* </div> */}
                                                {/* </div> */}

                                                <div className="col-md-6 mb-3 mb-md-0">
                                                    {/* ================================
   Interest Only Period Selection
================================ */}
                                                    {isInterestOnly && (
                                                        <div className="">
                                                            <label className="col-form-label">
                                                                {t("Interest Only Period")}{" "}
                                                                <Tooltip content={t("InterestOnlyPeriod_Tooltip")}>
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            {/* <h6>Interest Only Period</h6> */}

                                                            <div className="form-group row">
                                                                <div className="col-12 col-md-6">

                                                                    <div className="form-check">
                                                                        <input
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            name="interestOnlyType"
                                                                            value="BILL"
                                                                            checked={interestOnlyType === "BILL"}
                                                                            onChange={() => handleSwitchToBill()}
                                                                        />
                                                                        <label className="form-check-label">Bill</label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6">

                                                                    <div className="form-check">
                                                                        <input
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            name="interestOnlyType"
                                                                            value="CAPITALIZE"
                                                                            checked={interestOnlyType === "CAPITALIZE"}
                                                                            onChange={() => handleSwitchToCapitalize()}
                                                                        />
                                                                        <label className="form-check-label">Capitalize</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {isInterestOnly && interestOnlyType === "BILL" && (
                                                <div className="card mt-3 p-3">
                                                    <h6>Interest Only – Bill</h6>

                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Period</th>
                                                                <th>Interest Rate</th>
                                                                <th>Day Convention</th>
                                                                <th>Bill Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {billedRows.map((row, index) => (
                                                                <tr key={index}>
                                                                    <td>{row.period}</td>

                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            step="0.0001"
                                                                            className="form-control"
                                                                            value={row.interestRate}
                                                                            // onChange={(e) => {
                                                                            //     const updated = [...billedRows];
                                                                            //     updated[index].interestRate = e.target.value;
                                                                            //     updated[index].billAmount =
                                                                            //         calculateInterestAmount(
                                                                            //             vehicle_cost,
                                                                            //             e.target.value,
                                                                            //             actualInterestDays,
                                                                            //             updated[index].dayConvention
                                                                            //         );
                                                                            //     setBilledRows(updated);
                                                                            // }}
                                                                            onChange={(e) => {
                                                                                const updated = [...billedRows];
                                                                                const rate = e.target.value;

                                                                                updated[index].interestRate = rate;
                                                                                updated[index].billAmount =
                                                                                    calculateInterestAmount(
                                                                                        vehicle_cost,
                                                                                        rate,
                                                                                        row.periodDays, // ✅ CORRECT
                                                                                        dayConvention
                                                                                    );

                                                                                setBilledRows(updated);
                                                                            }}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <select
                                                                            className="form-control"
                                                                            value={row.dayConvention}
                                                                            onChange={(e) => {
                                                                                const updated = [...billedRows];
                                                                                const convention = e.target.value;

                                                                                updated[index].dayConvention = convention;

                                                                                updated[index].billAmount =
                                                                                    calculateInterestAmount(
                                                                                        vehicle_cost,
                                                                                        updated[index].interestRate,
                                                                                        updated[index].periodDays,   // ✅ per-period days
                                                                                        convention                  // ✅ per-row convention
                                                                                    );

                                                                                setBilledRows(updated);
                                                                            }}
                                                                        // value={dayConvention}
                                                                        //  onChange={(e) =>
                                                                        //                     setDayConvention(e.target.value)
                                                                        //                 }
                                                                        // onChange={(e) => {
                                                                        //     const updated = [...billedRows];
                                                                        //     updated[index].dayConvention = e.target.value;
                                                                        //     updated[index].billAmount =
                                                                        //         calculateBilledInterest(
                                                                        //             vehicle_cost,
                                                                        //             updated[index].interestRate,
                                                                        //             e.target.value
                                                                        //         );
                                                                        //     setBilledRows(updated);
                                                                        // }}
                                                                        >
                                                                            <option value="30/360">30/360</option>
                                                                            <option value="Actual/365">Actual / 365</option>
                                                                            <option value="Actual/360">Actual / 360</option>
                                                                        </select>
                                                                    </td>

                                                                    <td className="text-end">
                                                                        {row.billAmount}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                            {isInterestOnly && interestOnlyType === "CAPITALIZE" && (
                                                <div className="card mt-3 p-3">
                                                    <h6>Interest Only – Capitalize</h6>

                                                    {/* -------------------------------
            Capitalized Input Section
        -------------------------------- */}
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <label>Capitalize Interest Days</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={capitalizeDays}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label>Interest Rate</label>
                                                            <input
                                                                type="number"
                                                                step="0.0001"
                                                                className="form-control"
                                                                value={capitalizedInterestRate}
                                                                onChange={(e) =>
                                                                    setCapitalizedInterestRate(e.target.value)
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label>Day Convention</label>
                                                            <select
                                                                className="form-control"
                                                                value={dayConvention}
                                                                onChange={(e) =>
                                                                    setDayConvention(e.target.value)
                                                                }
                                                            >
                                                                <option value="30/360">30/360</option>
                                                                <option value="Actual/365">Actual / 365</option>
                                                                <option value="Actual/360">Actual / 360</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* -------------------------------
            Capitalized Summary (SINGLE ROW)
        -------------------------------- */}
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Loan Principal</th>
                                                                <th>Capitalize Interest</th>
                                                                <th>Total Loan Amount</th>
                                                                <th>Payment Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{vehicle_cost || 0}</td>
                                                                <td>{capitalizedInterest || "0.00"}</td>
                                                                <td>{totalLoanAmount || "0.00"}</td>
                                                                <td>{paymentAmount || "0.00"}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                        {/* </div> */}
                                        <div className="row mb-4">
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <label className="col-form-label">
                                                    {t("ACH Payments")}{" "}
                                                    <Tooltip content={t("ACH_Payments_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="achPayments"
                                                        checked={achPayments}
                                                        {...register("achPayments", {
                                                            onChange: (e) => setAchPayments(e.target.checked),
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor="achPayments">
                                                        Enable ACH Payments
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="col-form-label ">
                                                    {t("Bank Account")}{" "}
                                                    <Tooltip content={t("Bank_Account_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    id="achAccount"
                                                    {...register("achAccount", {
                                                        // required: achPayments ? "Bank Account is required when ACH Payments is enabled" : false,
                                                        required: false,
                                                        onChange: (e) => setAchAccount(e.target.value),
                                                    })}
                                                    value={achAccount}
                                                    disabled={!achPayments || achAccounts.length === 0}
                                                >
                                                    <option value="">Select Bank Account</option>
                                                    {achAccounts.map((account) => (
                                                        <option key={account.id} value={account.id}>
                                                            {account.account_name || `Account ${account.id}`}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="invalid-feedback">
                                                    {errors.achAccount && errors.achAccount.message}
                                                </div>
                                            </div>
                                        </div>

                                        {extrafiledcontract.length === 0 ? (
                                            ""
                                        ) : (
                                            <h5
                                                className="tc mt-4 cursor-pointer"
                                                onClick={toggleFields}
                                            >
                                                {t("Additional Information")}{" "}
                                                {isExpanded === true ? (
                                                    <FaAngleUp />
                                                ) : (
                                                    <FaAngleDown />
                                                )}
                                            </h5>
                                        )}
                                        {isExpanded === true && (
                                            <div className="form-group row">
                                                {extrafiledcontract.map((key, index) => (
                                                    <div
                                                        className={
                                                            key.enable === "True" ? "col-sm-6" : null
                                                        }
                                                    >
                                                        <>
                                                            <label
                                                                style={{
                                                                    display:
                                                                        key.enable === "True" ? true : "none",
                                                                }}
                                                                className="col-form-label"
                                                            >
                                                                {" "}
                                                                {key.label}{" "}
                                                                <Tooltip content={key.label}>
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <input
                                                                style={{
                                                                    display:
                                                                        key.enable === "True" ? true : "none",
                                                                }}
                                                                className="form-control mb-1"
                                                                name={"attribute" + index}
                                                                type={key.datatype}
                                                                placeholder={key.label}
                                                                onChange={(e) =>
                                                                    onChangeextrafileds(e, index)
                                                                }
                                                            />
                                                        </>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        <input
                                            type="hidden"
                                            value="Entered"
                                            className="form-control"
                                            name="status"
                                            id="status"
                                            disabled
                                        />
                                        <input
                                            type="hidden"
                                            className="form-control"
                                            name="sign_date"
                                            id="signdate"
                                        />
                                        <textarea
                                            style={{ display: "none" }}
                                            className="form-control"
                                            id="description"
                                            name="description"
                                        ></textarea>
                                        <input
                                            type="hidden"
                                            style={{ display: "none" }}
                                            value="USD"
                                            className="form-control"
                                            name="currency"
                                            id="currency"
                                        />
                                    </div>
                                )}

                                {currentStep === 4 && (
                                    <>
                                        {/* <h6 className="fw-bold mb-4">{t("Party Role")}</h6>
                                       <div className="row">
                                                 <div className="col-md-6 mt-2">
                                                     <div className="col-lg-12">
                                                         <label className="col-form-label ">
                                                                 {t("Party")}{" "}
                                                                 <Tooltip content={t("Party_Tooltip")}>
                                                                 <i className="fa fa-light fa-circle-info"></i>
                                                                 </Tooltip>
                                                             </label>
                                           <AsyncSelect
                                             {...register("selectedParty", {
                                              //  required: "Party is required",
                                               required: false,
                                             })}
                                             defaultOptions={partyoptions}
                                             isClearable
                                             placeholder={t("Search for Party(%for All)")}
                                             options={partyoptions}
                                             value={partyoptions.find(
                                               (option) => option.id === selectedParty
                                             )}
                                             getOptionLabel={(e) => e.customer_name}
                                             getOptionValue={(e) => e.customer_name}
                                             loadOptions={loadOptionsparty}
                                             onInputChange={handelInputChangeparty}
                                             onChange={handelChangeparty}
                                             name="selectedParty"
                                           ></AsyncSelect>
                                           <div className="invalid-feedback">
                                             {errors.selectedParty && errors.selectedParty.message}
                                           </div>
                                         </div>
                                                 </div>
                                                 <div className="col-md-6 mt-2">
                                                     <div className="form-group">
                                                         <label className="col-form-label ">
                                                                 {t("Role")}{" "}
                                                                 <Tooltip content={t("Role_Tooltip")}>
                                                                 <i className="fa fa-light fa-circle-info"></i>
                                                                 </Tooltip>
                                                             </label>
                                                          <select
                                                             onChange={(e) => setRole(e.target.value)}
                                                             id="role"
                                                             className="form-control"
                                                         >
                                                             <option value="">{t("Select")}</option>
                                                             <option value="GUARANTOR">{t("Guarantor")}</option>
                                                             <option  value="INSURANCE_PROVIDER">{t("Insurance Provider")}</option>
                                                             <option  value="PRIVATE_LABEL_HOLDER">{t("Private Label Holder")}</option>
                                                         </select>
                                                     </div>
                                                 </div>
                                                 </div> */}
                                        <div className="form-section">
                                            <h6 className="fw-bold mb-4">{t("Party Role")}</h6>
                                            <div className="row mb-4">
                                                <div className="col-md-5" style={{ zIndex: 999 }}>
                                                    <label className="col-form-label">{t("Party")}</label>
                                                    <AsyncSelect
                                                        {...register("selectedParty", {
                                                            required: false, // Validation handled by addPartyRole
                                                        })}
                                                        defaultOptions={partyOptions}
                                                        isClearable
                                                        placeholder={t("Search for Party (% for All)")}
                                                        options={partyOptions}
                                                        value={selectedParty}
                                                        getOptionLabel={(e) => e.customer_name}
                                                        getOptionValue={(e) => e.id}
                                                        loadOptions={loadOptionsparty}
                                                        onInputChange={handelInputChangeparty}
                                                        onChange={handelChangeparty}
                                                        name="selectedParty"
                                                    />
                                                    <div className="invalid-feedback">
                                                        {errors.selectedParty && errors.selectedParty.message}
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn-link add-new-link"
                                                        // onClick={() => setState1({ isPaneOpen: true })}
                                                        onClick={() => { setAddCustomerSource('step4'); setState1({ isPaneOpen: true }); }}
                                                    >
                                                        <Plus className="btn-icon-small" />
                                                        Add New Customer
                                                    </button>
                                                </div>
                                                <div className="col-md-5">
                                                    <label className="col-form-label">{t("Role")}</label>
                                                    <select
                                                        value={role}
                                                        onChange={(e) => setRole(e.target.value)}
                                                        className="form-control"
                                                    >
                                                        <option value="">{t("Select")}</option>
                                                        {rolesList.map((r) => (
                                                            <option key={r} value={r}>
                                                                {r}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2 d-flex align-items-end">
                                                    <button type="button" onClick={addPartyRole} className="btn btn-primary">
                                                        Add
                                                    </button>
                                                </div>
                                                <div className="col-md-5">
                                                    <label className="col-form-label">
                                                        {t("Comment")}{" "}
                                                        <Tooltip content={t("comment_Tooltip")}>
                                                            <i className="fa fa-light fa-circle-info"></i>
                                                        </Tooltip>
                                                    </label>
                                                    <div className="input-group">
                                                        <input
                                                            placeholder={t("Enter comment")}
                                                            className="form-control"
                                                            type="text"
                                                            name="comment"
                                                            maxLength="200"
                                                            id="comment"
                                                            value={comment}
                                                            onChange={(e) => setComment(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* {partyRoles.length > 0 && ( */}
                                            <MaterialTable
                                                title={t("Party Role")}
                                                // title={t("")}
                                                columns={[
                                                    { title: t("Party"), field: "partyName", render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Party")}</div><div>{rowData.partyName ? rowData.partyName : ""}</div></> },
                                                    { title: t("Role"), field: "role", render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Role")}</div><div>{rowData.role ? rowData.role : ""}</div></> },
                                                    { title: t("Comment"), field: "comment", render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Comment")}</div><div>{rowData.comment ? rowData.comment : ""}</div></> },
                                                ]}
                                                data={partyRoles}
                                                actions={[
                                                    {
                                                        //  icon: 'delete',
                                                        icon: () => <span ><img src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'} alt="Edit" /></span>,
                                                        tooltip: 'Delete',
                                                        onClick: (event, rowData) => deletePartyRole(partyRoles.indexOf(rowData)),
                                                    },
                                                ]}
                                                options={{
                                                    actionsColumnIndex: -1,
                                                    paging: false,
                                                    search: false,
                                                    headerStyle: {
                                                        backgroundColor: "white",
                                                        color: "#245C7F",
                                                        fontSize: 11,
                                                    },
                                                    rowStyle: (rowData, index) => ({
                                                        backgroundColor: index % 2 ? "#fff" : "#f8f9fa",
                                                    }),
                                                }}
                                            />
                                            {/* )} */}
                                        </div>
                                    </>
                                )}

                                {currentStep === 5 && (
                                    <div className="form-section">
                                        <h6 className="fw-bold mb-4">{t("Terms & Conditions")}</h6>

                                        <div className="row mb-4">

                                            {/* TERM NAME */}
                                            <div className="col-md-5">
                                                <label className="col-form-label">{t("Term Name")}</label>
                                                <select
                                                    className="form-control"
                                                    value={selectedTermName}
                                                    onChange={(e) => handleTermsChange(e.target.value)}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {termsList.map((t) => (
                                                        <option key={t.id} value={t.name}>
                                                            {t.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* VALUE */}
                                            <div className="col-md-5">
                                                <label className="col-form-label">{t("Value")}</label>
                                                <textarea
                                                    className="form-control"
                                                    value={selectedTermValue}
                                                    onChange={(e) => setSelectedTermValue(e.target.value)}
                                                />
                                            </div>

                                            {/* ADD BUTTON */}
                                            <div className="col-md-2 d-flex align-items-end">
                                                <button type="button" onClick={addTerm} className="btn btn-primary">
                                                    Add
                                                </button>
                                            </div>

                                        </div>

                                        {/* TABLE */}
                                        <MaterialTable
                                            title={t("Terms & Conditions")}
                                            columns={[
                                                {
                                                    title: t("Term"),
                                                    field: "name",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Term")}
                                                            </div>
                                                            <div>{rowData.name}</div>
                                                        </>
                                                    ),
                                                },
                                                {
                                                    title: t("Value"),
                                                    field: "value",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Value")}
                                                            </div>
                                                            <div>{rowData.value}</div>
                                                        </>
                                                    ),
                                                },
                                            ]}
                                            data={contractTerms}
                                            actions={[
                                                {
                                                    icon: () => (
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"}
                                                            alt="delete"
                                                        />
                                                    ),
                                                    tooltip: "Delete",
                                                    onClick: (event, rowData) =>
                                                        deleteTerm(contractTerms.indexOf(rowData)),
                                                },
                                            ]}
                                            options={{
                                                actionsColumnIndex: -1,
                                                paging: false,
                                                search: false,
                                                headerStyle: {
                                                    backgroundColor: "white",
                                                    color: "#245C7F",
                                                    fontSize: 11,
                                                },
                                                rowStyle: (rowData, index) => ({
                                                    backgroundColor: index % 2 ? "#fff" : "#f8f9fa",
                                                }),
                                            }}
                                        />
                                    </div>
                                )}

                                <div className="form-actions">
                                    <div>
                                        {currentStep > 1 && (
                                            <button
                                                type="button"
                                                onClick={prevStep}
                                                className="btn btn-outline-secondary"
                                            >
                                                Previous
                                            </button>
                                        )}
                                    </div>

                                    <div className="action-buttons">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary me-2"
                                            onClick={handelCancelClick}
                                        >
                                            Cancel
                                        </button>

                                        {currentStep < totalSteps ? (
                                            <button
                                                type="button"
                                                onClick={handleNextClick}
                                                className="btn btn-primary"
                                            >
                                                Next
                                                <ArrowRight className="btn-icon" />
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                <Save className="btn-icon" />
                                                Save
                                            </button>
                                        )}
                                        <CheckButton style={{ display: "none" }} ref={checkBtn} />

                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
                {/* Contract Summary - Right Side */}
                <div className="col-lg-4 col-md-12">
                    <ContractLeaseSummary
                        state="Loan"
                        currentStep={currentStep}
                        totalSteps={totalSteps}
                        data={options}
                        contract_number={contract_number}
                        selectedCustomer={selectedValue}
                        billToAddress={filterBill}
                        address_id={address_id}
                        installAddress={filteredOptions}
                        reg_address1={reg_address1}
                        start_date={start_date}
                        contract_term={contract_term}
                        vendorName={filteredVendor}
                        vender={vendername1}
                        asset_typeselection={asset_type.length === 1 ? asset_typesetting : asset_typeselection}
                        vehicle_cost={vehicle_cost}
                        asset_desc={asset_desc}
                        frequency={frequency}
                        paymentstart_date={paymentstartdate}
                        iir={iir}
                        achPayments={achPayments}
                        achAccount={achAccounts.find((acc) => acc.id === achAccount)?.account_name || ""}
                        appOriginator={appOriginator}
                        source={source}
                        salesRep={salesRep}
                        subcompany={subcompanyOptions.find((sub) => sub.id === parseInt(subcompany))?.sub_company_name}
                        lineOfBusiness={lineOfBusinessOptions.find((lob) => lob.id === parseInt(lineOfBusiness))?.lob_name}
                    />
                </div>
            </div>
        </div>
    )
}

export default CreateLoan